import * as React from 'react';
import BPromise from 'bluebird';
import { Component } from 'react';
import { Participant, SchoolEvent, SchoolEventCricketResult } from '../../../../../../models/event';
import { AppUser } from '../../../../../../views/App/App';
import { History, Location } from 'history';
import { parse } from 'query-string';
import { Loader } from '../../../../../../components/Loader/Loader';
import './SchoolEventView.scss';
import '../SchoolEvents.scss';
import {
  finishEvent,
  getEventAvailableUsers,
  getSchoolEvent,
  setEventResultsMode,
  sendEventNotification,
  sendEventNotificationEligibleStudents,
  addSchoolInEvent,
  changeSchoolInEvent,
  removeSchoolsFromEvent,
  sendEventNotificationNow,
  scheduleEventNotification
} from '../../../../../../helpers/service/admin/event';
import { getSchoolsPublic } from '../../../../../../helpers/service/public/public';
import { getSchoolEvents, reasonForCancellation } from '../../../../../../helpers/service/admin/schoolEvents';
import { ActionsButton } from '../../../../../../components/ActionsButton/ActionsButton';
import {
  getActionList,
  getActionListWithSubItems,
  getNextEventFilter,
  getPreviousEventFilter
} from '../../../../../../helpers/event/schoolEventViewHelper';
import { SchoolEventNavigationButtons } from './SchoolEventNavigationButtons';
import { SchoolEventMainInformation } from './SchoolEventMainInformation';
import { SchoolEventNewTweetButton } from './SchoolEventNewTweetButton';
import { SchoolEventTabs } from './SchoolEventTabs';
import './SchoolEventPageShell.scss';
import { SimpleModal } from '../../../../../../components/SimpleModal/SimpleModal';
import { getMatchCompetitors, RichMatchResultEditor } from '../../../../../../components/RichMatchResultEditor/RichMatchResultEditor';
import { UnsavedChangesModal } from '../../../../../../components/UnsavedChangesModal/UnsavedChangesModal';
import { SendRequestPageShell } from 'Src/components/SendRequestPageShell/SendRequestPageShell';
import {
  getAllSchoolIdsFromEvent,
  getEventParticipants,
  isEventStatusFinished,
  isHousesEvent,
  isInternalEvent,
  isInterSchoolsEvent,
  isMultipartyEvent,
  isNonTeamSportEvent,
  isTeamOrTwoOnTwoSportEvent,
  isClubEvent,
  isLeagueEvent,
  isIndividualSportEvent
} from '../../../../../../helpers/event/event';
import { IndividualInternalResults } from './ResultsViews/IndividualInternalResults';
import {
  createCricketResults,
  createHouseScore,
  createIndividualScore,
  createSchoolScore,
  createTeamScore,
  updateHouseScore,
  updateIndividualScore,
  updateSchoolScore,
  updateTeamScore
} from '../../../../../../helpers/service/admin/eventResults';
import { IndividualInternalHousesResults } from './ResultsViews/IndividualInternalHousesResults';
import { IndividualExternalSchoolsResults } from './ResultsViews/IndividualExternalSchoolsResults';
import { TeamInternalResults } from './ResultsViews/TeamInternalResults';
import { TeamInternalHousesResults } from './ResultsViews/TeamInternalHousesResults';
import { TeamExternalSchoolsResults } from './ResultsViews/TeamExternalSchoolsResults';
import { SchoolEventsEditSettingsForm } from '../SchoolEventsEditSettingsForm/SchoolEventsEditSettingsForm';
import { SchoolForm } from '../../../../../../models/form';
import { getAllForms } from '../../../../../../helpers/service/admin/forms';
import {
  cancelEvent,
  uncancelEvent,
  deleteEvent,
  getActionDescriptor,
  updateGroupSchoolClubEvents,
  updateActionDescriptor,
  updateSchoolEvent,
  updateSchoolEventDetails,
  updateGroupSchoolEventDetails
} from '../../../../../../helpers/service/admin/schoolEvents';
import { USER_GENDER_TYPE } from '../../../../../../types/user';
import { EventCustomNotificationWizard } from './EventCustomNotificationWizard/EventCustomNotificationWizard';
import { getVenueTypeByPostcode, getNewPoint } from '../../../../../../helpers/venue/venue';
import { getVideoConfig } from '../../../../../../helpers/service/nobody/config';
import { getKey } from '../../../../../../helpers/service/nobody/key';
import S3 = require('aws-sdk/clients/s3');
import { addConvertJob } from '../../../../../../helpers/service/nobody/aws';
import { addEventPinnedVideo } from '../../../../../../helpers/service/admin/eventVideos';
import { SendNotificationEligibleStudentsForm } from './SendNotificationEligibleStudentsForm/SendNotificationEligibleStudentsForm';
import propz from 'propz';
import { CLUB_EVENT_EDIT_MODE, EVENT_NOTIFICATION_MODE, EVENT_RESULTS_MODE } from '../../../../../../consts/event';
import { getEventGeneratedName } from '../../../../../../helpers/accessor/accessor';
import { getSafeFileName } from '../../../../../../helpers/file/file';
import { IndividualInternalExtraPoints } from './ExtraPointsView/IndividualInternalExtraPoints';
import { IndividualInternalHousesExtraPoints } from './ExtraPointsView/IndividualInternalHousesExtraPoints';
import { IndividualExternalSchoolsExtraPoints } from './ExtraPointsView/IndividualExternalSchoolsExtraPoints';
import { SchoolEventAddSchoolForm } from '../SchoolEventAddSchoolForm/SchoolEventAddSchoolForm';
import { removeSchoolEventIndividualPlayer } from '../../../../../../helpers/service/admin/tournamentTeams';
import { SchoolEventChangeSchoolForm } from '../SchoolEventChangeSchoolForm/SchoolEventChangeSchoolForm';
import {
  getConsentRequestTemplate,
  sendConsentRequest
} from '../../../../../../helpers/service/admin/consentRequestTemplate';
import { uploadReport } from '../../../../../../helpers/service/admin/report';
import { ConsentRequestTemplate } from '../../../../../../models/consentRequestTemplate';
import { FormDefinition } from '../../../../../../types/formSchema';
import {
  ConsentRequestForm,
  ConsentRequestFormField
} from '../SchoolEventConsentRequestForm/SchoolEventConsentRequestForm';
import moment from 'moment';
import { INPUT_MASK_VALIDATION } from '../../../../../../consts/date';
import { isCricket } from '../../../../../../helpers/sport/cricket';
import { CricketExternalSchoolsResults } from './ResultsViews/CricketExternalSchoolsResults';
import { applyEventCommunicationCancellationAction, getEventCommunicationCancellationImpact } from 'Src/helpers/service/eventCommunications';
import { CricketInternalResults } from './ResultsViews/CricketInternalResults';
import { CricketInternalHousesResults } from './ResultsViews/CricketInternalHousesResults';
import { SchoolEventsCreateAnotherEventAlert } from '../SchoolEventsCreateAnotherEventAlert/SchoolEventsCreateAnotherEventAlert';
import { MODE_TYPE } from '../../../../../../consts/common';
import { removeSchoolEventTeam } from '../../../../../../helpers/service/admin/schoolEventTeams';
import { STAFF_LIST } from '../../../../../../consts/user';
import { SchoolEventTwitterModal } from './Twitter/SchoolEventTwitterForm';
import { createTweet } from '../../../../../../helpers/service/admin/integrations';
import { updateEventSetting } from '../../../../../../helpers/service/admin/event';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../../../../../consts/table';
import { Map } from '../../../../../../components/Map/Map';
import { ExtendedTeamSheetReportForm } from './Reports/ExtendedTeamSheetReportForm/ExtendedTeamSheetReportForm';
import { ExtendedParticipantListReportForm } from './Reports/ExtendedParticipantListReportForm/ExtendedParticipantListReportForm';
import { BasicTeamSheetReportForm } from './Reports/BasicTeamSheetReportForm/BasicTeamSheetReportForm';
import { EventConsentRequestsReportForm } from './Reports/EventConsentRequestsReportForm/EventConsentRequestsReportForm';
import { EventAvailabilityReportsReportForm } from './Reports/EventAvailabilityReportsReportForm/EventAvailabilityReportsReportForm';
import { EventScoreCardReportForm } from './Reports/EventScoreCardReportForm/EventScoreCardReportForm';
import { CautionsDismissalsReportForm } from './Reports/CautionsDismissalsReportForm/CautionsDismissalsReportForm';
import { StudentTargetCompletionReportForm } from './Reports/StudentTargetCompletionReportForm/StudentTargetCompletionReportForm';
import { PaperAttendanceRegisterEventReportForm } from './Reports/PaperAttendanceRegisterEventReportForm/PaperAttendanceRegisterEventReportForm';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { REPORT_PRINT_FORMAT } from '../../../../../../consts/report';
import { Button } from '../../../../../../components/Button/Button';
import {
  HTML_FIRST_PART_PAGE_CODE,
  HTML_LAST_PART_PAGE_CODE
} from '../../../../../../components/HTMLEditorQuill/HTMLEditorConst';
import { getKitLabKits } from '../../../../../../helpers/service/admin/kitLab';
import { pickKitForEvent } from '../../../../../../helpers/kitLab/kitLab';

const SEND_CONSENT_REQUEST_QUERY_PARAM = 'sendConsentRequest';

export interface EventActionButtonCallbacks {
  EDIT_EVENT_SETTINGS: () => void;
  DUPLICATE_EVENT: () => void;
  ADD_SCHOOL: () => void;
  ADD_TEAM: () => void;
  ADD_RESULTS: () => void;
  UPDATE_RESULTS: () => void;
  UPDATE_POINTS: () => void;
  SEND_CONSENT_REQUEST: () => void;
  CANCEL_EVENT: () => void;
  CANCEL_EVENT_AND_EDIT_NOTIFICATION_LIST: () => void;
  UNCANCEL_EVENT: () => void;
  REPORT_AVAILABILITY: () => void;
  PRINT: () => void;
  DOWNLOAD_CSV: () => void;
  DELETE_EVENT: () => void;
  IMPORT_RESULTS_FROM_QUANTUM: () => void;
  EXPORT_START_LIST_TO_MACSHA_ONE_4_ALL: () => void;
  IMPORT_RESULTS_FROM_MACSHA_ONE_4_ALL: () => void;
  CLEAN_SCHOOL_LIST: () => void;
  SEND_EVENT_NOTIFICATION: () => void;
  SEND_EVENT_NOTIFICATION_ELIGIBLE_STUDENTS: () => void;
  IMPORT_RESULTS: () => void;
  IMPORT_RESULTS_FROM_QUANTUM_AQ: () => void;
  CLONE_TOURNAMENT_EVENT: () => void;
  ARBITER_BOARD: () => void;
  ADD_VIDEO: () => void;
}

function getExplicitTeamKitFromTeam(team: any, allKits: any[]): any | null {
  if (!Array.isArray(allKits) || !allKits.length) return null;

  const kitId = propz.get(team, ['kitLabKitId'], null);
  if (!kitId) return null;

  const kitIdStr = kitId.toString();
  return allKits.find(k => k._id && k._id.toString() === kitIdStr) || null;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  isLoading: boolean;
  event: SchoolEvent;
  prevEvent: SchoolEvent;
  nextEvent: SchoolEvent;
  forms: SchoolForm[];
  isResultsModalOpen: boolean;
  isResultsDirty: boolean;
  isResultsDiscardModalOpen: boolean;
  resultsSearch: string;
  appliedResultsSearch: string;
  teamResultEntryMode: 'SIMPLE' | 'MATCH_DETAILS';
  isExtraPointsModalOpen: boolean;
  isExtraPointsDirty: boolean;
  isExtraPointsDiscardModalOpen: boolean;
  isEditableEventSettings: boolean;
  isSendNotificationModalOpen: boolean;
  isSendNotificationEligibleStudentsModalOpen: boolean;
  availableUsers: AvailableUserExtended[];
  isVideoModalOpen: boolean;
  isCancelEventModalOpen: boolean;
  isUncancelEventModalOpen: boolean;
  cancelReason: string;
  cancellationCommunicationImpact?: {publicChatOpen: boolean; openPrivateCount: number; needsReplyCount: number; protectedCount: number};
  cancellationPublicReadOnly: boolean;
  cancellationResolveAnsweredPrivate: boolean;
  reasonForChange: string;
  errorMessage: string;
  isErrorModalOpen: boolean;
  actionDescriptorId: string;
  actionDescriptorIds: string[];
  tabIndex: number;
  isDeleteEventModalOpen: boolean;
  isSuccessDeleteEventModalOpen: boolean;
  isAddSchoolModalOpen: boolean;
  isChangeSchoolModalOpen: boolean;
  isRemoveParticipantModalOpen: boolean;
  isMapModalOpen: boolean;
  participant: Participant;
  isOneParticipant: boolean;
  consentRequestTemplate?: ConsentRequestTemplate;
  isSendConsentRequestModalOpen: boolean;
  isSuccessSendConsentRequestModalOpen: boolean;
  consentRequestSuccessMessage: string;
  isShowCreateAnotherEventAlert: boolean;
  isTwitterModalOpen: boolean;
  bodyText: string;
  isPostTweetModalOpen: boolean;
  participants: Participant[];
  isBasicTeamSheetReportFormModalOpen: boolean;
  isExtendedTeamSheetReportFormModalOpen: boolean;
  isExtendedParticipantListReportFormModalOpen: boolean;
  isEventConsentRequestsReportFormModalOpen: boolean;
  isEventAvailabilityReportsReportFormModalOpen: boolean;
  isEventScoreCardReportFormModalOpen: boolean;
  isCautionsDismissalsReportFormModalOpen: boolean;
  isStudentTargetCompletionReportFormModalOpen: boolean;
  isPaperAttendanceRegisterEventReportFormModalOpen: boolean;
  isPrintSelectionModalOpen: boolean;
}

interface AvailableUser {
  extra: {
    type: string;
  };
  firstName: string;
  gender: USER_GENDER_TYPE;
  lastName: string;
  permissionId: string;
  userId: string;
  userIdStr: string;
}

export interface AvailableUserExtended extends AvailableUser {
  isChecked: boolean;
}

export class SchoolEventView extends Component<Props, State> {
  private loadRequestId = 0;
  videoFileInput: any;

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      event: undefined,
      participants: [],
      prevEvent: undefined,
      nextEvent: undefined,
      forms: [],
      isResultsModalOpen: false,
      isResultsDirty: false,
      isResultsDiscardModalOpen: false,
      resultsSearch: '',
      appliedResultsSearch: '',
      teamResultEntryMode: 'SIMPLE',
      isExtraPointsModalOpen: false,
      isExtraPointsDirty: false,
      isExtraPointsDiscardModalOpen: false,
      isVideoModalOpen: false,
      isEditableEventSettings: false,
      availableUsers: [],
      isSendNotificationModalOpen: false,
      isSendNotificationEligibleStudentsModalOpen: false,
      isCancelEventModalOpen: false,
      cancelReason: '',
      cancellationPublicReadOnly: true,
      cancellationResolveAnsweredPrivate: false,
      isUncancelEventModalOpen: false,
      reasonForChange: '',
      errorMessage: '',
      isErrorModalOpen: false,
      actionDescriptorId: undefined,
      actionDescriptorIds: [],
      tabIndex: undefined,
      isDeleteEventModalOpen: false,
      isSuccessDeleteEventModalOpen: false,
      isAddSchoolModalOpen: false,
      isChangeSchoolModalOpen: false,
      isRemoveParticipantModalOpen: false,
      isMapModalOpen: false,
      participant: undefined,
      isOneParticipant: false,
      consentRequestTemplate: undefined,
      isSendConsentRequestModalOpen: false,
      isSuccessSendConsentRequestModalOpen: false,
      consentRequestSuccessMessage: '',
      isShowCreateAnotherEventAlert: false,
      isTwitterModalOpen: false,
      bodyText: '',
      isPostTweetModalOpen: false,
      isBasicTeamSheetReportFormModalOpen: false,
      isExtendedTeamSheetReportFormModalOpen: false,
      isExtendedParticipantListReportFormModalOpen: false,
      isEventConsentRequestsReportFormModalOpen: false,
      isEventAvailabilityReportsReportFormModalOpen: false,
      isEventScoreCardReportFormModalOpen: false,
      isCautionsDismissalsReportFormModalOpen: false,
      isStudentTargetCompletionReportFormModalOpen: false,
      isPaperAttendanceRegisterEventReportFormModalOpen: false,
      isPrintSelectionModalOpen: false
    };

    this.videoFileInput = React.createRef();
  }

  getEventId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const eventId = search.id;
    return eventId;
  }

  getMode(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const mode = propz.get(search, ['mode'], '');

    return mode;
  }

  //reload component after change eventId by navigation buttons
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location } = this.props;
    const { location: nextLocation } = nextProps;
    const { search } = location;
    const { search: nextSearch } = nextLocation;

    if (search !== nextSearch) {
      this.setState({
        isLoading: true
      });
      this.load();
    }
  }

  load() {
    const requestId = ++this.loadRequestId;
    const { user, location } = this.props;
    const calendarFilterType = propz.get(location, ['state', 'filter']);
    const eventId = this.getEventId();
    const mode = this.getMode();
    const isShowCreateAnotherEventAlert = mode === MODE_TYPE.CREATE_ANOTHER_EVENT;

    let event, prevEvent, nextEvent;

    // 1. Get current event
    // 2. Get previous/next events (for navigation) and forms
    getSchoolEvent(user, eventId)
      .then(_event => {
        event = _event;
        const eventName = getEventGeneratedName(_event, { user }) || 'Event';
        const tournamentName = propz.get(_event, ['tournament', 'name'], '');
        const eventBreadcrumb = tournamentName ? `${tournamentName} / Manage events / ${eventName}` : eventName;
        const breadcrumb = this.isSendConsentRequestPageOpen() ? `${eventBreadcrumb} / Consent form` : eventBreadcrumb;
        window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: breadcrumb }));

        const allSchoolIds = getAllSchoolIdsFromEvent(event);

        const filter = {
          where: { id: { $in: allSchoolIds } },
          view: {
            type: 'id_name_pic'
          },
          skip: DEFAULT_SKIP,
          limit: DEFAULT_LIMIT
        };

        const currentEventStartTime = new Date(_event.startTime);

        const nextEventFilter = getNextEventFilter(eventId, currentEventStartTime, user, calendarFilterType);
        const prevEventFilter = getPreviousEventFilter(eventId, currentEventStartTime, user, calendarFilterType);

        const prevEventPromise = getSchoolEvents(user, prevEventFilter);
        const nextEventPromise = getSchoolEvents(user, nextEventFilter);
        const getFormsPromise = getAllForms(user);

        const schoolsPromise = getSchoolsPublic(filter);

        return BPromise.all([prevEventPromise, nextEventPromise, getFormsPromise, schoolsPromise]);
      })
      .then(([_prevEvent, _nextEvent, forms, schools]) => {
        if (requestId !== this.loadRequestId) return;
        [prevEvent] = _prevEvent;
        [nextEvent] = _nextEvent;
        const participants = getEventParticipants(event, user, schools);

        this.setState(
          {
            isLoading: false,
            event,
            nextEvent,
            prevEvent,
            forms,
            participants,
            isShowCreateAnotherEventAlert
          },
          () => {
            this.maybeAutoAssignKitForCurrentSchool();
          }
        );
      })
      .catch(error => {
        if (requestId !== this.loadRequestId) return;
        this.showRequestError(error, 'The event could not be loaded. Please try again.');
      });
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.load();

    if (this.isSendConsentRequestPageOpen()) {
      getConsentRequestTemplate(this.props.user)
        .then(template => {
          this.setState({ consentRequestTemplate: template });
        })
        .catch(error => {
          this.showRequestError(error, 'The consent form could not be loaded. Please try again.');
        });
    }
  }

  showRequestError = (error: any, fallbackMessage: string): void => {
    const errorText =
      propz.get(error, ['response', 'data', 'details', 'text'], '') ||
      propz.get(error, ['response', 'data', 'message'], '') ||
      propz.get(error, ['message'], '') ||
      fallbackMessage;

    this.setState({
      isLoading: false,
      errorMessage: errorText,
      isErrorModalOpen: true
    });
  };

  componentWillUnmount() {
    this.loadRequestId += 1;
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
  }

  onPrevEventClick = () => {
    const { prevEvent } = this.state;
    const { history, location } = this.props;
    const { id } = prevEvent;
    const state = propz.get(location, ['state'], {});

    history.push({
      pathname: '/events/event',
      search: `id=${id}`,
      state
    });
  };

  onNextEventClick = () => {
    const { nextEvent } = this.state;
    const { history, location } = this.props;
    const { id } = nextEvent;
    const state = propz.get(location, ['state'], {});

    history.push({
      pathname: '/events/event',
      search: `id=${id}`,
      state
    });
  };

  emptyFunc = () => {};

  updateExtraPoints = () => {
    this.setState({
      isExtraPointsModalOpen: true,
      isExtraPointsDirty: false
    });
  };

  closeEvent = () => {
    const { event } = this.state;
    this.setState({
      isResultsModalOpen: true,
      isResultsDirty: false,
      resultsSearch: '',
      appliedResultsSearch: '',
      teamResultEntryMode: event && event.matchResult ? 'MATCH_DETAILS' : 'SIMPLE'
    });
  };

  onArbiterBoardClick = () => {
    const { history } = this.props;
    const { event } = this.state;
    const { id } = event;

    history.push({
      pathname: '/events/arbiterBoard',
      search: `id=${id}`
    });
  };

  addTeam = () => {
    const { history } = this.props;
    const { event } = this.state;
    const { id } = event;

    history.push({
      pathname: '/events/teamManager',
      search: `event=${id}`
    });
  };

  addSchool = () => {
    this.setState({
      isAddSchoolModalOpen: true
    });
  };

  onAddVideoClick = () => {
    let event;
    //This is true only for IE,firefox
    //Dirty hack from https://codeproject.com/Tips/893254/JavaScript-Triggering-Event-Manually-in-Internet-E
    //However, MDN recommend use very similar polyfill https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent#Polyfill
    if (document.createEvent) {
      // To create a mouse event , first we need to create an event and then initialize it.
      event = document.createEvent('MouseEvent');
      event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    } else {
      event = new MouseEvent('click');
    }
    this.videoFileInput.dispatchEvent(event);
  };

  sendEventNotificationEligibleStudents = () => {
    this.setState({
      isSendNotificationEligibleStudentsModalOpen: true
    });
  };

  isSendConsentRequestPageOpen = (): boolean => {
    return new URLSearchParams(this.props.location.search).get(SEND_CONSENT_REQUEST_QUERY_PARAM) === '1';
  };

  openSendConsentRequestPage = (): void => {
    const { history, location } = this.props;
    const params = new URLSearchParams(location.search);
    params.set(SEND_CONSENT_REQUEST_QUERY_PARAM, '1');

    const eventName = getEventGeneratedName(this.state.event, { user: this.props.user }) || 'Event';
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: `${eventName} / Consent form` }));

    history.push({
      pathname: location.pathname,
      search: '?' + params.toString()
    });
  };

  closeSendConsentRequestPage = (): void => {
    const { history, location } = this.props;
    const params = new URLSearchParams(location.search);
    params.delete(SEND_CONSENT_REQUEST_QUERY_PARAM);
    const eventName = getEventGeneratedName(this.state.event, { user: this.props.user }) || 'Event';
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: eventName }));
    const search = params.toString();

    history.push({
      pathname: location.pathname,
      search: search ? '?' + search : ''
    });
  };
  sendConsentRequest = () => {
    const { user } = this.props;
    const eventStartTime = new Date(this.state.event.startTime).getTime();
    if (!Number.isFinite(eventStartTime) || eventStartTime <= Date.now()) {
      return;
    }

    this.setState({
      isLoading: true
    });

    getConsentRequestTemplate(user)
      .then(template => {
        this.setState(
          {
            isSendConsentRequestModalOpen: true,
            isLoading: false,
            consentRequestTemplate: template
          },
          this.openSendConsentRequestPage
        );
      })
      .catch(error => {
        this.showRequestError(error, 'The consent form could not be loaded. Please try again.');
      });
  };

  copyEvent = () => {
    const { history } = this.props;
    const { event } = this.state;
    const { id } = event;

    history.push({
      pathname: '/events/copyManager',
      search: `event=${id}`
    });
  };

  getCallbacks(): EventActionButtonCallbacks {
    return {
      EDIT_EVENT_SETTINGS: this.onEditEventSettingsButtonClick,
      DUPLICATE_EVENT: this.copyEvent,
      ADD_SCHOOL: this.addSchool,
      ADD_TEAM: this.addTeam,
      ADD_RESULTS: this.closeEvent,
      UPDATE_RESULTS: this.closeEvent,
      UPDATE_POINTS: this.updateExtraPoints,
      SEND_CONSENT_REQUEST: this.sendConsentRequest,
      CANCEL_EVENT: this.cancelEventModalOpen,
      CANCEL_EVENT_AND_EDIT_NOTIFICATION_LIST: this.emptyFunc,
      UNCANCEL_EVENT: this.uncancelEventModalOpen,
      REPORT_AVAILABILITY: this.emptyFunc,
      PRINT: this.openPrintSelectionModal,
      DOWNLOAD_CSV: this.emptyFunc,
      DELETE_EVENT: this.deleteEventModalOpen,
      IMPORT_RESULTS_FROM_QUANTUM: this.emptyFunc,
      EXPORT_START_LIST_TO_MACSHA_ONE_4_ALL: this.emptyFunc,
      IMPORT_RESULTS_FROM_MACSHA_ONE_4_ALL: this.emptyFunc,
      CLEAN_SCHOOL_LIST: this.emptyFunc,
      SEND_EVENT_NOTIFICATION: this.sendEventNotification,
      SEND_EVENT_NOTIFICATION_ELIGIBLE_STUDENTS: this.sendEventNotificationEligibleStudents,
      IMPORT_RESULTS: this.emptyFunc,
      IMPORT_RESULTS_FROM_QUANTUM_AQ: this.emptyFunc,
      CLONE_TOURNAMENT_EVENT: this.emptyFunc,
      ARBITER_BOARD: this.onArbiterBoardClick,
      ADD_VIDEO: this.onAddVideoClick
    };
  }

  sendEventNotification = () => {
    const { user } = this.props;
    const { event } = this.state;

    this.setState({
      isLoading: true
    });

    getEventAvailableUsers(user, event.id)
      .then((availableUsers: AvailableUser[]) => {
        this.setState({
          isLoading: false,
          isSendNotificationModalOpen: true,
          availableUsers: availableUsers.map(user => ({
            ...user,
            isChecked: true
          }))
        });
      })
      .catch(error => {
        this.showRequestError(error, 'The notification recipients could not be loaded. Please try again.');
      });
  };

  getResultsView() {
    const { event } = this.state;
    const { user } = this.props;
    switch (true) {
      case isCricket(event) && isInternalEvent(event) && !isMultipartyEvent(event):
        return (
          <CricketInternalResults
            event={event}
            onSaveClick={this.onCricketResultsSaveClick}
            onCloseClick={this.onCloseResultsModalClick}
          />
        );
      case isCricket(event) && isHousesEvent(event) && !isMultipartyEvent(event):
        return (
          <CricketInternalHousesResults
            event={event}
            onSaveClick={this.onCricketResultsSaveClick}
            onCloseClick={this.onCloseResultsModalClick}
          />
        );
      case isCricket(event) && isInterSchoolsEvent(event) && !isMultipartyEvent(event):
        return (
          <CricketExternalSchoolsResults
            event={event}
            onSaveClick={this.onCricketResultsSaveClick}
            onCloseClick={this.onCloseResultsModalClick}
            user={user}
          />
        );
      case isNonTeamSportEvent(event) && isInternalEvent(event):
        return (
          <IndividualInternalResults
            event={event}
            onSaveClick={this.onResultsSaveClick}
            onCloseClick={this.onCloseResultsModalClick}
          />
        );
      case isNonTeamSportEvent(event) && isHousesEvent(event):
        return (
          <IndividualInternalHousesResults
            event={event}
            onSaveClick={this.onResultsSaveClick}
            onCloseClick={this.onCloseResultsModalClick}
          />
        );
      case isNonTeamSportEvent(event) && isInterSchoolsEvent(event):
        return (
          <IndividualExternalSchoolsResults
            event={event}
            onSaveClick={this.onResultsSaveClick}
            onCloseClick={this.onCloseResultsModalClick}
            user={user}
          />
        );
      case isTeamOrTwoOnTwoSportEvent(event) && isInternalEvent(event):
        return (
          <TeamInternalResults
            event={event}
            onSaveClick={this.onResultsSaveClick}
            onCloseClick={this.onCloseResultsModalClick}
          />
        );
      case isTeamOrTwoOnTwoSportEvent(event) && isHousesEvent(event):
        return (
          <TeamInternalHousesResults
            event={event}
            onSaveClick={this.onResultsSaveClick}
            onCloseClick={this.onCloseResultsModalClick}
          />
        );
      case isTeamOrTwoOnTwoSportEvent(event) && isInterSchoolsEvent(event):
        return (
          <TeamExternalSchoolsResults
            event={event}
            onSaveClick={this.onResultsSaveClick}
            onCloseClick={this.onCloseResultsModalClick}
            user={user}
          />
        );
      default:
        return <h1>Coming soon</h1>;
    }
  }

  getExtraPointsView() {
    const { event } = this.state;
    const { user } = this.props;
    switch (true) {
      case isNonTeamSportEvent(event) && isInternalEvent(event):
        return (
          <IndividualInternalExtraPoints
            event={event}
            onSaveClick={this.onExtraPointsSaveClick}
            onCloseClick={this.onCloseExtraPointsModalClick}
            onDirtyChange={isExtraPointsDirty => this.setState({ isExtraPointsDirty })}
          />
        );
      case isNonTeamSportEvent(event) && isHousesEvent(event):
        return (
          <IndividualInternalHousesExtraPoints
            event={event}
            onSaveClick={this.onExtraPointsSaveClick}
            onCloseClick={this.onCloseExtraPointsModalClick}
            onDirtyChange={isExtraPointsDirty => this.setState({ isExtraPointsDirty })}
          />
        );
      case isNonTeamSportEvent(event) && isInterSchoolsEvent(event):
        return (
          <IndividualExternalSchoolsExtraPoints
            event={event}
            user={user}
            onSaveClick={this.onExtraPointsSaveClick}
            onCloseClick={this.onCloseExtraPointsModalClick}
            onDirtyChange={isExtraPointsDirty => this.setState({ isExtraPointsDirty })}
          />
        );
      default:
        return <h1>Coming soon</h1>;
    }
  }

  private onEventResultSaveError = (error: any): void => {
    const errorText =
      propz.get(error, ['response', 'data', 'details', 'text']) ||
      propz.get(error, ['response', 'data', 'message']) ||
      'The event results could not be saved. Please try again.';
    console.error(error);
    this.setState({
      isLoading: false,
      errorMessage: errorText,
      isErrorModalOpen: true
    });
  };

  onExtraPointsSaveClick = scores => {
    const { event } = this.state;
    const { user } = this.props;
    const { id } = event;

    this.setState({ isLoading: true });
    let promises = [];

    promises = promises.concat(
      scores.filter(score => typeof score.scoreId === 'undefined').map(score => createIndividualScore(user, id, score))
    );

    promises = promises.concat(
      scores
        .filter(score => typeof score.scoreId !== 'undefined')
        .map(score => updateIndividualScore(user, id, score.scoreId, score))
    );

    BPromise.all(promises)
      .then(res => {
        this.setState({
          isExtraPointsModalOpen: false,
          isExtraPointsDirty: false,
          isLoading: true
        });
        this.load();
      })
      .catch(this.onEventResultSaveError);
  };

  onCloseExtraPointsModalClick = (): void => {
    if (this.state.isExtraPointsDirty) {
      this.setState({ isExtraPointsDiscardModalOpen: true });
      return;
    }
    this.setState({
      isExtraPointsModalOpen: false
    });
  };

  discardExtraPointsChanges = () => {
    this.setState({
      isExtraPointsModalOpen: false,
      isExtraPointsDirty: false,
      isExtraPointsDiscardModalOpen: false
    });
  };

  onCloseResultsModalClick = (): void => {
    if (this.state.isResultsDirty) {
      this.setState({ isResultsDiscardModalOpen: true });
      return;
    }
    this.setState({
      isResultsModalOpen: false
    });
  };

  discardResultsChanges = () => {
    this.setState({
      isResultsModalOpen: false,
      isResultsDirty: false,
      isResultsDiscardModalOpen: false,
      resultsSearch: '',
      appliedResultsSearch: ''
    });
  };

  onResultsSearchChange = (resultsSearch: string) => {
    this.setState({ resultsSearch });
  };

  applyResultsSearch = () => {
    const { resultsSearch } = this.state;
    this.setState({ appliedResultsSearch: resultsSearch }, () => {
      const query = resultsSearch.trim().toLowerCase();
      document.querySelectorAll<HTMLElement>('.eResultsModal tbody tr').forEach(row => {
        row.style.display =
          !query ||
          String(row.textContent || '')
            .toLowerCase()
            .includes(query)
            ? ''
            : 'none';
      });
    });
  };

  saveResultMetadataAndFinish = (resultsMode?: string, settingData?: any) => {
    const { event } = this.state;
    const { user } = this.props;

    return BPromise.resolve()
      .then(() => (typeof settingData !== 'undefined' ? updateEventSetting(user, event.id, settingData) : true))
      .then(() => (typeof resultsMode !== 'undefined' ? setEventResultsMode(user, event.id, resultsMode) : true))
      .then(() => (!isEventStatusFinished(event) ? finishEvent(user, event.id) : true));
  };

  onCricketResultsSaveClick = (scores: any, cricketResult: SchoolEventCricketResult) => {
    const { event } = this.state;
    const { user } = this.props;
    const { id } = event;

    this.setState({ isLoading: true });
    let promises = [];

    switch (true) {
      case isInternalEvent(event):
        //players
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createIndividualScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateIndividualScore(user, id, score.scoreId, score))
        );

        //teams
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createTeamScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateTeamScore(user, id, score.scoreId, score))
        );

        break;
      case isHousesEvent(event):
        //players
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createIndividualScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateIndividualScore(user, id, score.scoreId, score))
        );

        //teams
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined' && typeof score.teamId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createTeamScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined' && typeof score.teamId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateTeamScore(user, id, score.scoreId, score))
        );

        //houses
        promises = promises.concat(
          scores
            .filter(score => typeof score.houseId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createHouseScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.houseId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateHouseScore(user, id, score.scoreId, score))
        );
        break;
      case isInterSchoolsEvent(event):
        //players
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createIndividualScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateIndividualScore(user, id, score.scoreId, score))
        );

        //teams
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined' && typeof score.teamId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createTeamScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined' && typeof score.teamId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateTeamScore(user, id, score.scoreId, score))
        );

        //schools
        promises = promises.concat(
          scores
            .filter(score => typeof score.schoolId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createSchoolScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.schoolId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateSchoolScore(user, id, score.scoreId, score))
        );
        break;
      default:
        this.setState({
          isResultsModalOpen: false
        });
    }

    BPromise.all(promises)
      .then(() => createCricketResults(user, id, cricketResult))
      .then(() => this.saveResultMetadataAndFinish())
      .then(res => {
        this.setState({
          isResultsModalOpen: false,
          isLoading: true
        });
        this.load();
      })
      .catch(this.onEventResultSaveError);
  };

  onResultsSaveClick = (scores, resultsMode?: string, settingData?: any): void => {
    const { event } = this.state;
    const { user } = this.props;
    const { id } = event;

    this.setState({ isLoading: true });
    let promises = [];

    switch (true) {
      case isNonTeamSportEvent(event) && isInternalEvent(event):
      case isNonTeamSportEvent(event) && isHousesEvent(event):
      case isNonTeamSportEvent(event) && isInterSchoolsEvent(event):
        promises = promises.concat(
          scores
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => {
              let scoreData = {
                ...score,
                richScore: {
                  ...score.richScore,
                  ...(score.abbreviationResult && { abbreviationResult: score.abbreviationResult })
                }
              };
              delete scoreData.abbreviationResult;
              return createIndividualScore(user, id, scoreData);
            })
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => {
              let scoreData = {
                ...score,
                richScore: {
                  ...score.richScore,
                  ...(score.abbreviationResult && { abbreviationResult: score.abbreviationResult })
                }
              };
              delete scoreData.abbreviationResult;
              return updateIndividualScore(user, id, score.scoreId, scoreData);
            })
        );

        BPromise.all(promises)
          .then(() => this.saveResultMetadataAndFinish(resultsMode, settingData))
          .then(res => {
            this.setState({
              isResultsModalOpen: false,
              isLoading: true
            });
            this.load();
          })
          .catch(this.onEventResultSaveError);
        break;
      case isTeamOrTwoOnTwoSportEvent(event) && isInternalEvent(event):
        //players
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createIndividualScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateIndividualScore(user, id, score.scoreId, score))
        );

        //teams
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createTeamScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateTeamScore(user, id, score.scoreId, score))
        );

        BPromise.all(promises)
          .then(() => this.saveResultMetadataAndFinish(resultsMode, settingData))
          .then(res => {
            this.setState({
              isResultsModalOpen: false,
              isLoading: true
            });
            this.load();
          })
          .catch(this.onEventResultSaveError);
        break;
      case isTeamOrTwoOnTwoSportEvent(event) && isHousesEvent(event):
        //players
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createIndividualScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateIndividualScore(user, id, score.scoreId, score))
        );

        //teams
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined' && typeof score.teamId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createTeamScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined' && typeof score.teamId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateTeamScore(user, id, score.scoreId, score))
        );

        //houses
        promises = promises.concat(
          scores
            .filter(score => typeof score.houseId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createHouseScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.houseId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateHouseScore(user, id, score.scoreId, score))
        );

        BPromise.all(promises)
          .then(() => this.saveResultMetadataAndFinish(resultsMode, settingData))
          .then(res => {
            this.setState({
              isResultsModalOpen: false,
              isLoading: true
            });
            this.load();
          })
          .catch(this.onEventResultSaveError);
        break;
      case isTeamOrTwoOnTwoSportEvent(event) && isInterSchoolsEvent(event):
        //players
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => createIndividualScore(user, id, score))
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => updateIndividualScore(user, id, score.scoreId, score))
        );

        //teams
        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined' && typeof score.teamId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => {
              let scoreData = {
                ...score,
                richScore: {
                  ...score.richScore,
                  ...(score.abbreviationResult && { abbreviationResult: score.abbreviationResult })
                }
              };
              delete scoreData.abbreviationResult;
              return createTeamScore(user, id, scoreData);
            })
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.userId === 'undefined' && typeof score.teamId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => {
              let scoreData = {
                ...score,
                richScore: {
                  ...score.richScore,
                  ...(score.abbreviationResult && { abbreviationResult: score.abbreviationResult })
                }
              };
              delete scoreData.abbreviationResult;
              return updateTeamScore(user, id, score.scoreId, scoreData);
            })
        );

        //schools
        promises = promises.concat(
          scores
            .filter(score => typeof score.schoolId !== 'undefined')
            .filter(score => typeof score.scoreId === 'undefined')
            .map(score => {
              let scoreData = {
                ...score,
                richScore: {
                  ...score.richScore,
                  ...(score.abbreviationResult && { abbreviationResult: score.abbreviationResult })
                }
              };
              delete scoreData.abbreviationResult;
              return createSchoolScore(user, id, scoreData);
            })
        );

        promises = promises.concat(
          scores
            .filter(score => typeof score.schoolId !== 'undefined')
            .filter(score => typeof score.scoreId !== 'undefined')
            .map(score => {
              let scoreData = {
                ...score,
                richScore: {
                  ...score.richScore,
                  ...(score.abbreviationResult && { abbreviationResult: score.abbreviationResult })
                }
              };
              delete scoreData.abbreviationResult;
              return updateSchoolScore(user, id, score.scoreId, scoreData);
            })
        );

        BPromise.all(promises)
          .then(() => this.saveResultMetadataAndFinish(resultsMode, settingData))
          .then(res => {
            this.setState({
              isResultsModalOpen: false,
              isLoading: true
            });
            this.load();
          })
          .catch(this.onEventResultSaveError);
        break;
      default:
        this.setState({
          isResultsModalOpen: false,
          isLoading: false
        });
    }
  };

  onSubmitEventSettingsForm = (data, editMode, reasonForChange): void => {
    const { user } = this.props;
    const { activeSchool } = user;
    const { event } = this.state;
    const {
      startTime,
      endTime,
      venue,
      leaguePositionsCount,
      photos,
      isStudentCanSubmitResult,
      isStudentCanJoin,
      shortDescription,
      ...rest
    } = data;
    const oldShortDescription = propz.get(event, ['eventDetails', 'shortDescription'], '');
    const isEqualShortDescription = oldShortDescription === shortDescription;
    const isEmptyDescriptions = oldShortDescription === '' && shortDescription === '';
    const detailsData = {
      shortDescription
    };

    const hasStartTimeChanged = moment(event.startTime).toISOString() !== moment(startTime).toISOString();
    const hasEndTimeChanged = moment(event.endTime).toISOString() !== moment(endTime).toISOString();
    const hasVenueChanged = JSON.stringify(event.venue) !== JSON.stringify(venue);

    const isNotificationNeeded = hasStartTimeChanged || hasEndTimeChanged || hasVenueChanged;

    const isEventUpdateNotificationCustomMessageEnabled = propz.get(
      user,
      ['activeSchool', 'isEventUpdateNotificationCustomMessageEnabled'],
      false
    );

    const notificationMode = isNotificationNeeded
      ? isEventUpdateNotificationCustomMessageEnabled
        ? EVENT_NOTIFICATION_MODE.MANUAL
        : EVENT_NOTIFICATION_MODE.AUTO
      : EVENT_NOTIFICATION_MODE.NONE;

    const body =
      editMode === CLUB_EVENT_EDIT_MODE.SINGLE
        ? {
            ...rest,
            venue,
            ...(typeof photos !== 'undefined' ? { photos } : {}),
            ...(typeof isStudentCanSubmitResult !== 'undefined' ? { isStudentCanSubmitResult } : {}),
            ...(typeof isStudentCanJoin !== 'undefined' ? { isStudentCanJoin } : {}),
            startTime: moment(startTime).toISOString(),
            endTime: moment(endTime).toISOString(),
            ...(typeof leaguePositionsCount !== 'undefined'
              ? { leaguePositionsCount: Number(leaguePositionsCount) }
              : {}),
            reasonForChange,
            shortDescription
          }
        : {
            ...rest,
            venue,
            startTime: moment(startTime).toISOString(),
            endTime: moment(endTime).toISOString(),
            reasonForChange,
            shortDescription
          };

    switch (true) {
      case typeof venue !== 'undefined' && typeof venue.point !== 'undefined' && venue.point.coordinates.length > 0:
        if (typeof venue.postcodeId === 'undefined') {
          body.venue.postcodeId = venue.id;
        }
        body.venue.venueType = getVenueTypeByPostcode(venue, activeSchool);
        break;
      case typeof venue !== 'undefined' && typeof venue.point === 'undefined':
        body.venue.venueType = getVenueTypeByPostcode(venue, activeSchool);
        break;
      default:
        delete body.venue;
    }
    //TODO: fix it
    if (typeof venue.id !== 'undefined') {
      delete body.venue.id;
    }
    if (typeof venue.isHome !== 'undefined') {
      delete body.venue.isHome;
    }
    if (typeof venue.name !== 'undefined') {
      delete body.venue.name;
    }
    if (typeof venue.postcode !== 'undefined') {
      delete body.venue.postcode;
    }

    this.setState({
      isLoading: true
    });

    let currentActionDescriptorId;
    const singleEditMode = editMode === CLUB_EVENT_EDIT_MODE.SINGLE;
    const getEditEventService = singleEditMode
      ? updateSchoolEvent(user, event.id, body, notificationMode)
      : updateGroupSchoolClubEvents(user, event.id, body, notificationMode);

    getEditEventService
      .then(res => {
        currentActionDescriptorId = propz.get(res, ['headers', 'action-descriptor-id']);
        if (!isEqualShortDescription && !isEmptyDescriptions) {
          return singleEditMode
            ? updateSchoolEventDetails(user, event.id, detailsData)
            : updateGroupSchoolEventDetails(user, event.id, detailsData);
        } else {
          return BPromise.resolve(undefined);
        }
      })
      .then(res => {
        const isExistActionDescriptor = typeof currentActionDescriptorId !== 'undefined';

        if (isNotificationNeeded && isEventUpdateNotificationCustomMessageEnabled && isExistActionDescriptor) {
          return this.updateActionDescriptors([currentActionDescriptorId], reasonForChange);
        } else {
          this.setState({
            isEditableEventSettings: false,
            actionDescriptorId: undefined,
            isLoading: false
          });
          this.load();
        }
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);

        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  onCancelEventSettingsButtonClick = (): void => {
    this.setState({
      isEditableEventSettings: false
    });
  };

  onEditEventSettingsButtonClick = (): void => {
    this.setState({
      isEditableEventSettings: true
    });
  };

  cancelEventModalOpen = () => {
    this.setState({
      isCancelEventModalOpen: true,
      cancelReason: '',
      cancellationCommunicationImpact: undefined,
      cancellationPublicReadOnly: true,
      cancellationResolveAnsweredPrivate: false
    });
    if (propz.get(this.props.user, ['activeSchool', 'settings', 'eventComms', 'askOnEventCancellation'], true)) {
      getEventCommunicationCancellationImpact(this.props.user, this.state.event.id).then(cancellationCommunicationImpact => this.setState({cancellationCommunicationImpact})).catch(() => undefined);
    }
  };

  cancelEventModalClose = (): void => {
    this.setState({
      isCancelEventModalOpen: false
    });
  };

  uncancelEventModalOpen = () => {
    this.setState({
      isUncancelEventModalOpen: true
    });
  };

  uncancelEventModalClose = (): void => {
    this.setState({
      isUncancelEventModalOpen: false
    });
  };

  deleteEventModalOpen = () => {
    this.setState({
      isDeleteEventModalOpen: true
    });
  };

  deleteSuccessEventModalClose = (): void => {
    const { history } = this.props;
    this.setState({
      isSuccessDeleteEventModalOpen: false
    });
    history.push({
      pathname: '/calendar'
    });
  };

  deleteEventModalClose = () => {
    this.setState({
      isDeleteEventModalOpen: false
    });
  };

  renderResultsModal() {
    const { isResultsModalOpen, event } = this.state;
    const { user } = this.props;
    const resultsView = this.getResultsView();
    const eventName = getEventGeneratedName(event, { user }) || 'Event';
    const scoreCollections = ['schoolScore', 'houseScore', 'teamScore', 'individualScore'];
    const hasSavedScores = scoreCollections.some(key => {
      const scores = propz.get(event, ['results', key], []);
      return Array.isArray(scores) && scores.length > 0;
    });
    const cricketResult = propz.get(event, ['results', 'cricketResult']);
    const hasSavedResults = Boolean(event && event.matchResult) || hasSavedScores || Boolean(cricketResult && cricketResult.result);
    const isDetailedResultAvailable =
      !isCricket(event) &&
      !isMultipartyEvent(event) &&
      isTeamOrTwoOnTwoSportEvent(event) &&
      propz.get(event, ['resultsMode'], EVENT_RESULTS_MODE.RESULTS) === EVENT_RESULTS_MODE.RESULTS &&
      getMatchCompetitors(event).length === 2;
    const isRichTeamResult = isDetailedResultAvailable && this.state.teamResultEntryMode === 'MATCH_DETAILS';
    return (
      <SimpleModal
        customClass={`${
          isCricket(event) && !isMultipartyEvent(event) ? 'modal-lg' : 'mSchoolsResultsModalWidth'
        } eResultsModal`}
        bodyClassName="eResultsModal__body"
        isOpen={isResultsModalOpen}
        title={
          <div className="eResultsModal__title">
            <span className="eResultsModal__titleIcon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="M4 19V9M10 19V5M16 19v-7M22 19V3" />
              </svg>
            </span>
            <span>
              <strong>{hasSavedResults ? 'Update results' : 'Add results'}</strong>
              <small>{eventName}</small>
            </span>
          </div>
        }
        onCloseClick={this.onCloseResultsModalClick}
        onBackdropClick={this.onCloseResultsModalClick}
        showFooter={false}
        isBodyBold={false}
      >
        <div className="eResultsModal__toolbar">
          <div className="eResultsModal__intro">
            <strong>Enter results</strong>
            <span>Use ↑, ↓ or Enter to move between result fields.</span>
          </div>
          {isDetailedResultAvailable && <div className="eResultsModal__entryMode" role="group" aria-label="Result entry mode">
            <button
              type="button"
              className={this.state.teamResultEntryMode === 'SIMPLE' ? 'is-active' : ''}
              onClick={() => this.setState({teamResultEntryMode: 'SIMPLE'})}
            >Simple score</button>
            <button
              type="button"
              className={this.state.teamResultEntryMode === 'MATCH_DETAILS' ? 'is-active' : ''}
              onClick={() => this.setState({teamResultEntryMode: 'MATCH_DETAILS'})}
            >Match details</button>
          </div>}
          {!isRichTeamResult && <label className="eResultsModal__searchWrap">
            <input
              type="search"
              className="eResultsModal__search"
              aria-label="Search participants or teams"
              placeholder="Search participants or teams"
              value={this.state.resultsSearch}
              onChange={event => this.onResultsSearchChange(event.target.value)}
              onKeyDown={event => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  this.applyResultsSearch();
                }
              }}
            />
          </label>}
        </div>
        <div className="eResultsModal__content" onChange={() => this.setState({ isResultsDirty: true })}>
          {isRichTeamResult ? (
            <RichMatchResultEditor
              key={`${event.id}:${event.resultPublication?.updatedAt || ''}`}
              user={user}
              event={event}
              onSaved={() => this.setState({isResultsDirty: false}, () => this.reloadEvent(this.state.tabIndex))}
            />
          ) : resultsView}
        </div>
      </SimpleModal>
    );
  }

  renderResultsDiscardModal() {
    return (
      <UnsavedChangesModal
        isOpen={this.state.isResultsDiscardModalOpen}
        message="You have unsaved changes to the event results. If you close now, those changes will be lost."
        onDiscard={this.discardResultsChanges}
        onKeepEditing={() => this.setState({ isResultsDiscardModalOpen: false })}
      />
    );
  }

  renderExtraPointsModal() {
    const { isExtraPointsModalOpen } = this.state;
    const extraPointsView = this.getExtraPointsView();
    return (
      <SimpleModal
        customClass="eventPointsModal"
        dialogStyle={{ maxWidth: 780 }}
        isOpen={isExtraPointsModalOpen}
        onBackdropClick={this.onCloseExtraPointsModalClick}
      >
        {extraPointsView}
      </SimpleModal>
    );
  }

  renderExtraPointsDiscardModal() {
    return (
      <UnsavedChangesModal
        isOpen={this.state.isExtraPointsDiscardModalOpen}
        message="You have unsaved changes to participant points. If you close now, those changes will be lost."
        onDiscard={this.discardExtraPointsChanges}
        onKeepEditing={() => this.setState({ isExtraPointsDiscardModalOpen: false })}
      />
    );
  }

  onCloseVideoModal = () => {
    this.setState({
      isVideoModalOpen: false
    });
  };

  renderVideoModal() {
    const { isVideoModalOpen } = this.state;
    return (
      <SimpleModal
        title={'Add video'}
        body={'Success!'}
        buttonText={'Ok'}
        onButtonClick={this.onCloseVideoModal}
        isOpen={isVideoModalOpen}
      />
    );
  }

  renderEventSettingModal() {
    const { isEditableEventSettings, event, forms } = this.state;
    const { user } = this.props;

    return (
      <SimpleModal
        customClass="mSchoolEventEditSettingsFormWidth"
        isOpen={isEditableEventSettings}
        title={'Edit event details'}
        onCloseClick={this.onCancelEventSettingsButtonClick}
        showFooter={false}
        isBodyBold={false}
        bodyClassName="eSchoolEventEditModal__body"
        dialogStyle={{ maxWidth: 700 }}
      >
        <SchoolEventsEditSettingsForm
          user={user}
          schoolEvent={event}
          forms={forms}
          onCancel={this.onCancelEventSettingsButtonClick}
          onSubmit={this.onSubmitEventSettingsForm}
        />
      </SimpleModal>
    );
  }

  renderMapModal() {
    const { isMapModalOpen, event } = this.state;
    const { venue } = event;

    const point = getNewPoint(venue);
    const { coordinates } = point;
    const isCoordinatesExist = typeof coordinates !== 'undefined';

    if (isCoordinatesExist) {
      const [latitude, longitude] = coordinates;

      return (
        <SimpleModal
          isOpen={isMapModalOpen}
          title={'Venue'}
          buttonCancelText={'Close'}
          onCloseClick={this.closeMapModal}
        >
          <Map point={point} customStylingClass="mb-3 eClubWizardMap" isMarkerDraggable={false} />
          <div>
            <a
              target="_blank"
              href={`http://maps.google.com/maps?q=${longitude},${latitude}+(My+Point)&z=14&ll=${longitude},${latitude}`}
            >
              View on Google Maps
            </a>
          </div>
        </SimpleModal>
      );
    }
  }

  openMapModal = () => {
    this.setState({
      isMapModalOpen: true
    });
  };

  closeMapModal = () => {
    this.setState({
      isMapModalOpen: false
    });
  };

  onSubmitAddSchoolForm = (schoolId: string): void => {
    const { user } = this.props;
    const { event } = this.state;
    const { id } = event;

    this.setState({
      isLoading: true
    });

    addSchoolInEvent(user, id, schoolId)
      .then(eventUpdated => {
        this.setState({
          isLoading: false,
          event: eventUpdated,
          isAddSchoolModalOpen: false
        });

        this.load();
      })
      .catch(error => {
        this.showRequestError(error, 'The school could not be added to this event. Please try again.');
      });
  };

  onCancelAddSchoolButtonClick = () => {
    this.setState({
      isAddSchoolModalOpen: false
    });
  };

  renderAddSchoolModal() {
    const { isAddSchoolModalOpen, event } = this.state;
    const { user } = this.props;

    return (
      <SimpleModal
        customClass="eEventParticipantModal eEventParticipantModal--addSchool"
        isOpen={isAddSchoolModalOpen}
        title={'Add school'}
        onCloseClick={this.onCancelAddSchoolButtonClick}
        showFooter={false}
        isBodyBold={false}
      >
        <SchoolEventAddSchoolForm
          event={event}
          user={user}
          onCancel={this.onCancelAddSchoolButtonClick}
          onSubmit={this.onSubmitAddSchoolForm}
        />
      </SimpleModal>
    );
  }

  renderRemoveParticipantModal() {
    const { isRemoveParticipantModalOpen, participant } = this.state;
    const participantTeam = propz.get(participant, ['team']);
    const participantTeamName = propz.get(participant, ['team', 'name']);
    const participantSchoolName = propz.get(participant, ['school', 'name']);

    const body = participantTeam
      ? `Are you sure you want to remove ${participantTeamName} from ${participantSchoolName}`
      : `Are you sure you want to remove opponent ${participantSchoolName}`;

    return (
      <SimpleModal
        customClass="eEventParticipantModal eEventParticipantModal--danger"
        isOpen={isRemoveParticipantModalOpen}
        title={'Remove participant?'}
        onCloseClick={this.onCancelRemoveParticipantClick}
        onButtonClick={this.onRemoveParticipantModalClick}
        buttonText={'Yes, remove'}
        isBodyBold={false}
        body={
          <div className="eEventParticipantModal__message">
            <span className="eEventParticipantModal__icon" aria-hidden="true">
              !
            </span>
            <span>{body}?</span>
          </div>
        }
      />
    );
  }

  onCancelSentConsentRequestClick = () => {
    this.setState({
      isSendConsentRequestModalOpen: false
    });
    this.closeSendConsentRequestPage();
  };

  renderSentConsentRequestPage() {
    const { consentRequestTemplate } = this.state;

    if (!this.isSendConsentRequestPageOpen()) {
      return null;
    }

    if (!consentRequestTemplate) {
      return <Loader />;
    }

    return (
      <SendRequestPageShell
        className="SendRequestPageShell--consentRequest"
        title="Request consent"
        subtitle="Build the form parents will receive, preview it, then request their consent."
        onBack={this.onCancelSentConsentRequestClick}
      >
        <ConsentRequestForm
          user={this.props.user}
          template={consentRequestTemplate}
          onCancelClick={this.onCancelSentConsentRequestClick}
          onSendConsentRequestsClick={this.onSendConsentRequestClick}
          defaultBuilderMode="COMPACT"
        />
      </SendRequestPageShell>
    );
  }
  onSendConsentRequestClick = (
    fields: ConsentRequestFormField[],
    deadlineForAnswers: string,
    formDefinition?: FormDefinition
  ) => {
    const { event } = this.state;
    const eventStartTime = new Date(event.startTime).getTime();
    if (!Number.isFinite(eventStartTime) || (!deadlineForAnswers && eventStartTime <= Date.now())) {
      this.setState({
        errorMessage: !Number.isFinite(eventStartTime)
          ? 'Consent requests cannot be sent because the event start time is invalid.'
          : 'Consent requests without an earlier response deadline cannot be sent after the event has started.',
        isErrorModalOpen: true
      });
      return;
    }

    const { id: eventId } = event;
    const { user } = this.props;
    this.closeSendConsentRequestPage();
    this.setState({
      isLoading: true,
      isSendConsentRequestModalOpen: false
    });

    let data;
    if (deadlineForAnswers) {
      const deadlineForAnswersDate = moment(deadlineForAnswers, INPUT_MASK_VALIDATION, true).toDate();
      const deadlineForAnswersStr = deadlineForAnswersDate.toISOString();
      data = {
        fields: fields,
        ...(formDefinition ? { formSchemaVersion: 2, formDefinition } : {}),
        deadlineForAnswers: deadlineForAnswersStr
      };
    } else {
      data = {
        fields: fields,
        ...(formDefinition ? { formSchemaVersion: 2, formDefinition } : {}),
        deadlineForAnswers: null
      };
    }

    sendConsentRequest(user, eventId, data)
      .then(messages => {
        if (!Array.isArray(messages)) {
          throw new Error('Consent requests could not be sent because the server returned an invalid response.');
        }

        const createdCount = messages.length;
        const consentRequestSuccessMessage =
          createdCount > 0
            ? `${createdCount} consent request${createdCount === 1 ? '' : 's'} sent successfully.`
            : 'Existing unanswered consent requests were updated successfully. Requests that have already been answered were not changed.';

        this.setState({ consentRequestSuccessMessage });
        return getSchoolEvent(user, eventId);
      })
      .then(updatedEvent => {
        this.setState({
          event: updatedEvent,
          isLoading: false,
          isSuccessSendConsentRequestModalOpen: true
        });
      })
      .catch(error => {
        const errorText =
          propz.get(error, ['response', 'data', 'details', 'text'], '') ||
          propz.get(error, ['message'], '') ||
          'Consent requests could not be sent. Please try again.';
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  onRemoveParticipantClick = (participant: Participant, isOneParticipant: boolean): void => {
    this.setState({
      isRemoveParticipantModalOpen: true,
      participant: participant,
      isOneParticipant: isOneParticipant
    });
  };

  onCancelRemoveParticipantClick = () => {
    this.setState({
      isRemoveParticipantModalOpen: false,
      participant: undefined,
      isOneParticipant: false
    });
  };

  onCancelEventClick = () => {
    const { user } = this.props;
    const { event, cancelReason } = this.state;
    const eventId = event.id;
    const isEventUpdateNotificationCustomMessageEnabled = propz.get(
      user,
      ['activeSchool', 'isEventUpdateNotificationCustomMessageEnabled'],
      false
    );
    const notificationMode = isEventUpdateNotificationCustomMessageEnabled
      ? EVENT_NOTIFICATION_MODE.MANUAL
      : EVENT_NOTIFICATION_MODE.AUTO;

    this.setState({
      isLoading: true,
      isCancelEventModalOpen: false
    });

    cancelEvent(user, eventId, notificationMode)
      .then(async res => {
        if (this.state.cancellationCommunicationImpact) await applyEventCommunicationCancellationAction(user, eventId, {publicChat: this.state.cancellationPublicReadOnly ? 'READ_ONLY' : 'KEEP', resolveAnsweredPrivate: this.state.cancellationResolveAnsweredPrivate});
        const currentActionDescriptorId = propz.get(res, ['headers', 'action-descriptor-id']);
        const updateEvent = res.data;

        if (isEventUpdateNotificationCustomMessageEnabled && cancelReason) {
          const reasonForCancellationPromise = reasonForCancellation(user, eventId, cancelReason);
          return reasonForCancellationPromise.then(() => {
            this.updateActionDescriptors([currentActionDescriptorId], cancelReason);
          });
        } else {
          this.updateActionDescriptors([currentActionDescriptorId]);
        }
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  updateActionDescriptors = (actionDescriptorIds, additionalDescription = '') => {
    const { user } = this.props;
    const promises = actionDescriptorIds
      .filter(id => id)
      .map(actionDescriptorId => {
        return getActionDescriptor(user, actionDescriptorId)
          .then(actionDescriptor => {
            const USERS_COUNT_IN_CHUNK = 30;
            const usersFiltered = [...actionDescriptor.affectedUserList];
            let userChunks = [];

            for (let i = 0; i < usersFiltered.length; i += USERS_COUNT_IN_CHUNK) {
              const chunk = usersFiltered.slice(i, i + USERS_COUNT_IN_CHUNK);
              userChunks.push(chunk);
            }

            const userChunksCount = userChunks.length;

            return BPromise.all(
              userChunks.map((userChunk, index) => {
                const data = {
                  manualConfirmationStatus: index === userChunksCount - 1 ? 'CONFIRMED' : 'AWAITING_CONFIRMATION',
                  usersToNotifyList: userChunk,
                  additionalDescription: additionalDescription
                };
                return updateActionDescriptor(user, actionDescriptor.id, data);
              })
            );
          })
          .catch(error => {
            if (error.response && error.response.status === 404) {
              console.warn(`ActionDescriptor not found for id: ${actionDescriptorId}`);
            } else {
              const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
              console.error(`Error updating ActionDescriptor ${actionDescriptorId}:`, errorText);
              this.setState({
                isLoading: false,
                errorMessage: errorText,
                isErrorModalOpen: true
              });
            }
          });
      });

    return BPromise.all(promises)
      .then(() => {
        this.setState({
          isLoading: false,
          isEditableEventSettings: false,
          actionDescriptorIds: []
        });
        this.load();
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  renderCancelEventModal() {
    const { isCancelEventModalOpen, cancelReason } = this.state;
    const { user } = this.props;
    const { event } = this.state;
    const eventName = getEventGeneratedName(event, { user: user });
    const isEventUpdateNotificationCustomMessageEnabled = propz.get(
      user,
      ['activeSchool', 'isEventUpdateNotificationCustomMessageEnabled'],
      false
    );

    return (
      <SimpleModal
        isOpen={isCancelEventModalOpen}
        title="Cancel event?"
        onCloseClick={this.cancelEventModalClose}
        showFooter={false}
        customClass="eventCancelModal"
        dialogStyle={{ maxWidth: 500 }}
      >
        <div className="eventCancelForm">
          <div className="eventCancelForm__warning">
            <i>!</i>
            <div>
              <strong>Cancel this event</strong>
              <span>Participants may be notified about this change.</span>
            </div>
          </div>
          <p>
            Are you sure you want to cancel <b>{eventName}</b> (
            {moment(event.startTime).format('dddd, MMMM Do YYYY, h:mm a')})?
          </p>
          {this.state.cancellationCommunicationImpact && (this.state.cancellationCommunicationImpact.publicChatOpen || this.state.cancellationCommunicationImpact.openPrivateCount > 0) && <div className="eventCancelForm__communications">
            <strong>Open event conversations</strong>
            <p>{this.state.cancellationCommunicationImpact.openPrivateCount} open private chat{this.state.cancellationCommunicationImpact.openPrivateCount === 1 ? '' : 's'}{this.state.cancellationCommunicationImpact.needsReplyCount > 0 ? ` · ${this.state.cancellationCommunicationImpact.needsReplyCount} need a staff reply` : ''}.</p>
            {this.state.cancellationCommunicationImpact.protectedCount > 0 && <p className="eventCancelForm__communicationsWarning">{this.state.cancellationCommunicationImpact.protectedCount} conversation{this.state.cancellationCommunicationImpact.protectedCount === 1 ? ' is' : 's are'} protected, reported or awaiting moderation and will remain open.</p>}
            {this.state.cancellationCommunicationImpact.publicChatOpen && <label><input type="checkbox" checked={this.state.cancellationPublicReadOnly} onChange={event => this.setState({cancellationPublicReadOnly: event.target.checked})} /><span>Make the public chat staff-announcements-only</span></label>}
            {this.state.cancellationCommunicationImpact.openPrivateCount > 0 && <label><input type="checkbox" checked={this.state.cancellationResolveAnsweredPrivate} onChange={event => this.setState({cancellationResolveAnsweredPrivate: event.target.checked})} /><span>Resolve answered private chats</span></label>}
            <small>Chats needing a reply, reported messages and conversations protected for safeguarding are not resolved automatically.</small>
          </div>}
          {isEventUpdateNotificationCustomMessageEnabled && (
            <>
              <p className="eventCancelForm__hint">
                Add an optional note for team members and parents. Leave it empty to cancel without a reason.
              </p>
              <label htmlFor="cancelReason">
                Reason for cancellation <span>Optional</span>
              </label>
              <textarea
                id="cancelReason"
                value={cancelReason}
                placeholder="Enter cancellation reason"
                onChange={e => this.setState({ cancelReason: e.target.value })}
                className="eventCancelForm__textarea"
                rows={3}
              />
            </>
          )}
          <div className="eventCancelForm__actions">
            <button onClick={this.cancelEventModalClose}>Keep event active</button>
            <button className="is-danger" onClick={this.onCancelEventClick}>
              Confirm cancellation
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  onReasonEventSettingsFormSubmit = data => {
    const { actionDescriptorId } = this.state;
    const { user } = this.props;
    const additionalDescription = propz.get(data, ['body'], '');
    const isExistActionDescriptorId = typeof actionDescriptorId !== 'undefined';

    this.setState({
      isLoading: true
    });
    if (isExistActionDescriptorId) {
      getActionDescriptor(user, actionDescriptorId)
        .then(actionDescriptor => {
          const USERS_COUNT_IN_CHUNK = 30;
          const usersFiltered = [...actionDescriptor.affectedUserList];

          let userChunks = [];

          for (let i = 0; i < usersFiltered.length; i += USERS_COUNT_IN_CHUNK) {
            const chunk = usersFiltered.slice(i, i + USERS_COUNT_IN_CHUNK);
            userChunks.push(chunk);
          }
          const userChunksCount = userChunks.length;
          BPromise.all(
            userChunks.map((userChunk, index) => {
              const data = {
                manualConfirmationStatus: index === userChunksCount - 1 ? 'CONFIRMED' : 'AWAITING_CONFIRMATION',
                usersToNotifyList: userChunk,
                additionalDescription: additionalDescription
              };
              return updateActionDescriptor(user, actionDescriptor.id, data);
            })
          ).then(res => {
            this.setState({
              isLoading: false,
              actionDescriptorId: undefined
            });
            return true;
          });
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(error);
          this.setState({
            isLoading: false,
            errorMessage: errorText,
            isErrorModalOpen: true
          });
        });
      this.load();
    } else {
      console.error('actionDescriptorId is undefined');
      this.setState({
        isLoading: false,
        errorMessage: 'Error',
        isErrorModalOpen: true
      });
    }
  };

  onUncancelEventClick = () => {
    const { user } = this.props;
    const { event } = this.state;
    const eventId = event.id;

    this.setState({
      isLoading: true,
      isUncancelEventModalOpen: false
    });

    uncancelEvent(user, eventId)
      .then(res => {
        this.setState({ isLoading: false });
        this.load();
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  renderUncancelEventModal() {
    const { isUncancelEventModalOpen, event } = this.state;
    const { user } = this.props;
    const eventName = getEventGeneratedName(event, { user });

    return (
      <SimpleModal
        isOpen={isUncancelEventModalOpen}
        title="Restore cancelled event?"
        onCloseClick={this.uncancelEventModalClose}
        showFooter={false}
        customClass="eventConfirmModal"
      >
        <div className="eventConfirm">
          <i>↻</i>
          <h3>{eventName}</h3>
          <p>The event will become active again and return to event management.</p>
          <div>
            <button onClick={this.uncancelEventModalClose}>Keep cancelled</button>
            <button className="is-primary" onClick={this.onUncancelEventClick}>
              Restore event
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  onDeleteEventClick = () => {
    const { user } = this.props;
    const { event } = this.state;
    const { id } = event;

    this.setState({
      isDeleteEventModalOpen: false,
      isLoading: false
    });

    deleteEvent(user, id)
      .then(res => {
        this.setState({
          isSuccessDeleteEventModalOpen: true
        });
      })

      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  renderDeleteEventModal() {
    const { isDeleteEventModalOpen } = this.state;
    const { user } = this.props;
    const { event } = this.state;
    const eventName = getEventGeneratedName(event, { user: user });

    return (
      <SimpleModal
        isOpen={isDeleteEventModalOpen}
        title={'Remove Event'}
        buttonText={'Delete'}
        onButtonClick={this.onDeleteEventClick}
        onCloseClick={this.deleteEventModalClose}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: `Are you sure you want to remove <b>${eventName}</b> (${moment(event.startTime).format(
              'MMMM Do YYYY, h:mm a'
            )})?`
          }}
        />
      </SimpleModal>
    );
  }

  renderSuccessDeleteEventModal() {
    const { isSuccessDeleteEventModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isSuccessDeleteEventModalOpen}
        title={'Success'}
        body={`Event has been successfully removed`}
        buttonText={'Ok'}
        onButtonClick={this.deleteSuccessEventModalClose}
      />
    );
  }

  renderSuccessSendConsentRequestModal() {
    const { isSuccessSendConsentRequestModalOpen, consentRequestSuccessMessage } = this.state;

    return (
      <SimpleModal
        isOpen={isSuccessSendConsentRequestModalOpen}
        title={'Success'}
        onCloseClick={this.successSendConsentRequestModalClose}
        showFooter={false}
        isBodyBold={false}
        customClass="eventConsentSuccessModal"
      >
        <div className="eventConsentSuccess">
          <div className="eventConsentSuccess__message">
            <span className="eventConsentSuccess__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="m5 12.5 4.2 4.2L19 7" />
              </svg>
            </span>
            <div>
              <h3>Consent requests saved</h3>
              <p>{consentRequestSuccessMessage || 'Consent requests have been saved successfully.'}</p>
            </div>
          </div>
          <div className="eventConsentSuccess__actions">
            <button type="button" onClick={this.successSendConsentRequestModalClose}>
              Done
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  successSendConsentRequestModalClose = () => {
    this.setState({
      isSuccessSendConsentRequestModalOpen: false,
      consentRequestSuccessMessage: ''
    });
  };

  onSubmitSendNotification = async values => {
    const {
      emailSubject,
      emailBody,
      sendEmail,
      sendPush,
      pushTitle,
      pushBody,
      players,
      parents,
      staff,
      attachments,
      submitAction,
      scheduleAt
    } = values;
    const { event } = this.state;
    const { user } = this.props;

    const selected = [...players, ...parents, ...staff].filter(s => s.value);

    const usersToPost = selected.reduce((result, selectedUser) => {
      const permissionIds =
        Array.isArray(selectedUser.permissionIds) && selectedUser.permissionIds.length > 0
          ? selectedUser.permissionIds
          : [selectedUser.permissionId];
      permissionIds.filter(Boolean).forEach(permissionId => {
        result.push({ userId: selectedUser.name, permissionId });
      });
      return result;
    }, []);

    const styleLists = (html: string) => {
      const container = document.createElement('div');
      container.innerHTML = html;

      container.querySelectorAll('ul').forEach(ul => {
        const el = ul as HTMLElement;
        el.style.listStyleType = 'disc';
        el.style.listStylePosition = 'inside';
        el.style.margin = '1em 0';
        el.style.paddingLeft = '1.5em';
      });

      container.querySelectorAll('ol').forEach(ol => {
        const el = ol as HTMLElement;
        el.style.listStyleType = 'decimal';
        el.style.listStylePosition = 'inside';
        el.style.margin = '1em 0';
        el.style.paddingLeft = '1.5em';
      });

      container.querySelectorAll('li').forEach(li => {
        const el = li as HTMLElement;
        el.style.display = 'list-item';
        el.style.listStyleType = 'inherit';
        el.style.marginBottom = '0.5em';
      });

      return container.innerHTML;
    };

    const inlinedBody = sendEmail ? styleLists(emailBody) : '';
    const htmlEmail = HTML_FIRST_PART_PAGE_CODE + inlinedBody + HTML_LAST_PART_PAGE_CODE;

    const payload = {
      title: sendEmail ? emailSubject : pushTitle,
      text: sendEmail ? htmlEmail : '',
      content: {
        push: sendPush
          ? {
              title: pushTitle,
              body: pushBody
            }
          : {}
      },
      channels: {
        email: sendEmail,
        push: sendPush
      },
      attachments: sendEmail ? attachments : [],
      users: usersToPost
    };

    this.setState({ isLoading: true });

    try {
      const response = await sendEventNotification(user, event.id, payload);
      const actionDescriptorId = propz.get(response, ['headers', 'action-descriptor-id']);

      if (!actionDescriptorId) {
        throw new Error('actionDescriptorId is missing');
      }

      if (submitAction === 'SCHEDULE') {
        await scheduleEventNotification(user, event.id, actionDescriptorId, scheduleAt);
      } else {
        await sendEventNotificationNow(user, event.id, actionDescriptorId);
      }

      this.setState({
        isLoading: false,
        actionDescriptorId: '',
        isSendNotificationModalOpen: false
      });
    } catch (error) {
      const errorText =
        propz.get(error, ['response', 'data', 'details', 'text'], '') || propz.get(error, ['message'], '');

      this.setState({
        isLoading: false,
        errorMessage: errorText,
        isErrorModalOpen: true
      });
    }
  };

  onCancelSendNotification = () => {
    this.setState({
      isSendNotificationModalOpen: false
    });
  };

  onSubmitSendNotificationEligibleStudents = data => {
    const { event } = this.state;
    const { user } = this.props;
    const { title, text } = data;

    this.setState({
      isLoading: true
    });

    const dataToPost = {
      title,
      text
    };

    sendEventNotificationEligibleStudents(user, event.id, dataToPost)
      .then(() => {
        this.setState({
          isLoading: false,
          isSendNotificationEligibleStudentsModalOpen: false
        });
      })
      .catch(error => {
        this.showRequestError(error, 'The notification could not be sent. Please try again.');
      });
  };

  onCancelSendNotificationEligibleStudents = () => {
    this.setState({
      isSendNotificationEligibleStudentsModalOpen: false
    });
  };

  onVideoFileChange = eventDescriptor => {
    const { user } = this.props;
    const { event } = this.state;
    const { id } = event;
    const video = eventDescriptor.target.files[0];
    const { name } = video;
    const safeName = getSafeFileName(name);

    this.setState({
      isLoading: true
    });

    const promises = [getVideoConfig(user), getKey(user)];

    let s3, folderKey, folderName, videoFullName, bucket;

    BPromise.all(promises)
      .then(([videoConfig, keyObj]) => {
        const { accessKey, secretAccessKey, bucketRegion } = videoConfig;
        bucket = videoConfig.bucketName;

        s3 = new S3({
          region: bucketRegion,
          credentials: {
            accessKeyId: accessKey,
            secretAccessKey: secretAccessKey
          }
        });

        folderKey = keyObj.key;
        folderName = `orig/${folderKey}/`;
        videoFullName = folderName + safeName;

        return s3.putObject({ Key: folderName, Bucket: bucket }).promise();
      })
      .then(res => {
        return s3.putObject({ Key: videoFullName, Bucket: bucket, Body: video }).promise();
      })
      .then(res => {
        const data = {
          key: folderKey,
          fileName: safeName,
          bucketName: bucket
        };
        return addConvertJob(user, data);
      })
      .then(jobObj => {
        const job = jobObj.Job;
        const jobId = job.Id;

        const data = {
          videos: [
            {
              fileName: safeName,
              key: folderKey,
              jobId: jobId
            }
          ]
        };

        return addEventPinnedVideo(user, id, data);
      })
      .then(eventNext => {
        this.setState({
          isLoading: false,
          event: eventNext,
          isVideoModalOpen: true
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: JSON.stringify(error),
          isErrorModalOpen: true
        });
      });
  };

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: undefined
    });
  };

  renderError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title={'Error'}
        body={errorMessage}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseErrorClick}
      />
    );
  }

  renderSendNotificationsModal() {
    const { isSendNotificationModalOpen, availableUsers } = this.state;
    return (
      <SimpleModal
        title="Notify about this event"
        customClass="send-notifications-wizard"
        isOpen={isSendNotificationModalOpen}
        onBackdropClick={() => window.dispatchEvent(new CustomEvent('event-notify-close-request'))}
        onCloseIconClick={() => window.dispatchEvent(new CustomEvent('event-notify-close-request'))}
      >
        <EventCustomNotificationWizard
          user={this.props.user}
          event={this.state.event}
          availableUsers={availableUsers}
          onSubmit={this.onSubmitSendNotification}
          onCancel={this.onCancelSendNotification}
        />
      </SimpleModal>
    );
  }

  renderSendNotificationEligibleStudentsModal() {
    const { isSendNotificationEligibleStudentsModalOpen } = this.state;
    return (
      <SimpleModal isOpen={isSendNotificationEligibleStudentsModalOpen}>
        <SendNotificationEligibleStudentsForm
          onSubmit={this.onSubmitSendNotificationEligibleStudents}
          onCancel={this.onCancelSendNotificationEligibleStudents}
        />
      </SimpleModal>
    );
  }

  renderVideoFileInput() {
    return (
      <input
        className="eAddVideoButton_fileInput"
        type="file"
        accept="video/*"
        aria-label="Choose a video"
        onChange={this.onVideoFileChange}
        ref={input => (this.videoFileInput = input)}
      />
    );
  }

  reloadEvent = (tabIndex: number) => {
    const { user } = this.props;
    const eventId = this.getEventId();

    this.setState({
      isLoading: true
    });

    getSchoolEvent(user, eventId)
      .then(event => {
        this.setState({
          isLoading: false,
          event: event,
          tabIndex: tabIndex
        });
      })
      .catch(error => {
        this.showRequestError(error, 'The event could not be refreshed. Please try again.');
      });
  };

  onRemoveParticipantModalClick = (): void => {
    const { event, participant, isOneParticipant } = this.state;
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { team, school, house } = participant;
    const { id: participantSchoolId } = school;
    const isTeamExist = typeof team !== 'undefined';
    const isActiveSchoolParticipant = activeSchoolId === participantSchoolId;
    const eventId = this.getEventId();

    let promises = [];

    if (isNonTeamSportEvent(event)) {
      promises = promises.concat(
        participant.individualPlayers.map(player => removeSchoolEventIndividualPlayer(user, eventId, player.id))
      );
    }

    if (isTeamOrTwoOnTwoSportEvent(event) && isTeamExist) {
      const { id } = team;
      promises = promises.concat(removeSchoolEventTeam(user, eventId, id));
    }

    if (!isActiveSchoolParticipant && isOneParticipant) {
      promises = promises.concat(removeSchoolsFromEvent(user, eventId, [participantSchoolId]));
    }

    if (isHousesEvent(event)) {
      const { id: houseId } = house;
      const houses = event.houses.filter(eventHouseId => houseId !== eventHouseId);
      promises = promises.concat(updateSchoolEvent(user, eventId, { houses: houses }));
    }

    this.setState({
      isLoading: true,
      isRemoveParticipantModalOpen: false,
      participant: undefined,
      isOneParticipant: false
    });

    BPromise.all(promises)
      .then(res => getSchoolEvent(user, eventId))
      .then(event => {
        this.setState({
          isLoading: false,
          event: event
        });

        this.load();
      })
      .catch(error => {
        this.showRequestError(error, 'The participant could not be removed. Please try again.');
      });
  };

  onChangeSchoolClick = (participant: Participant): void => {
    this.setState({
      isChangeSchoolModalOpen: true,
      participant: participant
    });
  };

  onCancelChangeSchoolButtonClick = () => {
    this.setState({
      isChangeSchoolModalOpen: false,
      participant: undefined
    });
  };

  onSubmitChangeSchoolForm = (schoolId: string) => {
    const { user } = this.props;
    const { event, participant } = this.state;
    const { school } = participant;
    const { id: selectedSchoolId } = school;
    const { id } = event;

    this.setState({
      isLoading: true,
      isChangeSchoolModalOpen: false,
      participant: undefined
    });

    const invitedSchoolIds = (event.invitedSchoolIds || []).map(invitedSchoolId =>
      String(invitedSchoolId) === String(selectedSchoolId) ? schoolId : invitedSchoolId
    );

    changeSchoolInEvent(user, id, invitedSchoolIds)
      .then(() => {
        this.load();
      })
      .catch(error => {
        this.showRequestError(error, 'The opponent could not be changed. Please try again.');
      });
  };

  renderChangeSchoolModal() {
    const { isChangeSchoolModalOpen, event, participant } = this.state;
    const { user } = this.props;

    return (
      <SimpleModal
        customClass="eEventParticipantModal eEventParticipantModal--change"
        isOpen={isChangeSchoolModalOpen}
        title={'Change opponent'}
        onCloseClick={this.onCancelChangeSchoolButtonClick}
        showFooter={false}
        isBodyBold={false}
      >
        <SchoolEventChangeSchoolForm
          event={event}
          user={user}
          participant={participant}
          onCancel={this.onCancelChangeSchoolButtonClick}
          onSubmit={this.onSubmitChangeSchoolForm}
        />
      </SimpleModal>
    );
  }

  onCreateAnotherEventAlertCloseClick = () => {
    this.setState({
      isShowCreateAnotherEventAlert: false
    });
  };

  onCancelTwitterButtonClick = () => {
    this.setState({
      isTwitterModalOpen: false
    });
  };

  onOpenButtonClick = () => {
    this.setState({
      isTwitterModalOpen: true
    });
  };

  isTweetButtonRender() {
    const { user } = this.props;
    const twitterIntegrations = propz.get(user, ['activeSchool', 'integrations', 'twitter'], []);
    const activeRole = propz.get(user, ['activeRole'], '');
    const isActiveRoleStaff = STAFF_LIST.some(role => role === activeRole);

    return isActiveRoleStaff && twitterIntegrations.length > 0;
  }

  onSubmitTweet = values => {
    const { user } = this.props;
    const data = {
      text: values.text
    };

    this.setState({
      isLoading: true
    });

    const twitterId = values.twitterId;

    createTweet(user, twitterId, data)
      .then(res => {
        this.onCancelTwitterButtonClick();
        this.setState({
          bodyText: 'Your tweet has successfully been posted!',
          isLoading: false,
          isPostTweetModalOpen: true
        });
      })
      .catch(error => {
        this.showRequestError(error, 'The post could not be published. Please try again.');
      });
  };

  renderTwitterModal() {
    const { isTwitterModalOpen, event } = this.state;
    const { user } = this.props;

    return (
      <SimpleModal isOpen={isTwitterModalOpen} title={'Create tweet'}>
        <SchoolEventTwitterModal
          event={event}
          user={user}
          onCancel={this.onCancelTwitterButtonClick}
          onSubmit={this.onSubmitTweet}
        />
      </SimpleModal>
    );
  }

  onPostTweetModalClose = () => {
    this.setState({
      isPostTweetModalOpen: false
    });
  };

  renderSuccessPostedModal(): React.ReactNode {
    const { isPostTweetModalOpen, bodyText } = this.state;

    return (
      <SimpleModal
        isOpen={isPostTweetModalOpen}
        title={''}
        body={bodyText}
        buttonText={'Ok'}
        onButtonClick={this.onPostTweetModalClose}
      />
    );
  }

  openPrintSelectionModal = () => {
    this.setState({ isPrintSelectionModalOpen: true });
  };

  closePrintSelectionModal = () => {
    this.setState({ isPrintSelectionModalOpen: false });
  };

  selectPrintOption = (onSelect: () => void) => {
    this.setState({ isPrintSelectionModalOpen: false }, onSelect);
  };

  renderPrintSelectionModal() {
    const { isPrintSelectionModalOpen, event, participants } = this.state;
    const { user } = this.props;

    if (!event) return null;

    const players = propz.get(event, ['players'], []);
    const activeSchoolId = propz.get(user, ['activeSchoolId'], '');
    const hasActiveSchoolPlayers = players.some(player => player.schoolId === activeSchoolId);
    const hasParticipants = participants.length > 0;
    const isSport = !isClubEvent(event);
    const isAdminOrManager = user.activeRole === 'ADMIN' || user.activeRole === 'MANAGER';

    const groups = [
      {
        title: 'Participants',
        items: [
          isSport && {
            name: 'Basic team sheet',
            description: 'A concise team list for this fixture.',
            formats: 'PDF / Excel',
            disabled: !hasActiveSchoolPlayers,
            action: this.openBasicTeamSheetReportForm
          },
          isSport && {
            name: 'Extended team sheet',
            description: 'Full squad details with optional contact and event information.',
            formats: 'PDF / Excel',
            disabled: !hasActiveSchoolPlayers,
            action: this.openExtendedTeamSheetReportForm
          },
          !isSport && {
            name: 'Extended participant list',
            description: 'Participant details with configurable personal and event fields.',
            formats: 'PDF / Excel',
            disabled: !hasActiveSchoolPlayers,
            action: this.openExtendedParticipantListReportForm
          }
        ].filter(Boolean)
      },
      {
        title: 'On the day',
        items: [
          {
            name: 'Paper attendance register',
            description: 'A printable register for marking attendance by hand.',
            formats: isSport ? 'Excel' : 'PDF / Excel',
            disabled: !hasParticipants,
            action: isSport ? this.printPaperAttendanceRegisterFixture : this.openPaperAttendanceRegisterEventReportForm
          },
          isAdminOrManager && {
            name: 'Attendance log',
            description: 'Export the recorded attendance history for this event.',
            formats: 'Excel',
            disabled: !hasParticipants,
            action: this.printEventAttendanceLog
          },
          isSport &&
            !isMultipartyEvent(event) && {
              name: 'Event score card',
              description: 'A blank card for recording scores and results.',
              formats: 'PDF',
              disabled: false,
              action: this.openEventScoreCardReportForm
            }
        ].filter(Boolean)
      },
      {
        title: 'Records & compliance',
        items: [
          {
            name: 'Consent requests summary',
            description: 'Parental consent status and selected response details.',
            formats: 'Excel',
            disabled: !hasActiveSchoolPlayers,
            action: this.openEventConsentRequestsReportForm
          },
          {
            name: 'Availability reports summary',
            description: 'Participant availability responses for this event.',
            formats: 'Excel',
            disabled: !hasActiveSchoolPlayers,
            action: this.openEventAvailabilityReportsReportForm
          },
          isSport &&
            !isMultipartyEvent(event) && {
              name: 'Cautions & dismissals',
              description: 'Disciplinary records for this fixture.',
              formats: 'PDF / Excel',
              disabled: false,
              action: this.openCautionsDismissalsReportForm
            },
          isLeagueEvent(event) &&
            isIndividualSportEvent(event) && {
              name: 'Student target completion',
              description: 'Progress against student targets for this event.',
              formats: 'Excel',
              disabled: !hasActiveSchoolPlayers,
              action: this.openStudentTargetCompletionReportForm
            }
        ].filter(Boolean)
      }
    ];

    return (
      <SimpleModal
        customClass="eEventPrintModal"
        isOpen={isPrintSelectionModalOpen}
        title="Printed forms & reports"
        onCloseClick={this.closePrintSelectionModal}
        showFooter={false}
        isBodyBold={false}
      >
        <div className="eEventPrintModal__intro">
          Choose a document. You can configure its contents and format on the next step.
        </div>
        {groups.map(group => (
          <section className="eEventPrintModal__group" key={group.title}>
            <h3 className="eEventPrintModal__groupTitle">{group.title}</h3>
            <div className="eEventPrintModal__list">
              {group.items.map((item: any) => (
                <button
                  type="button"
                  className="eEventPrintModal__item"
                  key={item.name}
                  disabled={item.disabled}
                  onClick={() => this.selectPrintOption(item.action)}
                >
                  <span className="eEventPrintModal__itemIcon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M6 9V3h12v6M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6z" />
                    </svg>
                  </span>
                  <span className="eEventPrintModal__itemCopy">
                    <span className="eEventPrintModal__itemHeading">
                      <span>{item.name}</span>
                      <span className="eEventPrintModal__format">{item.formats}</span>
                    </span>
                    <span className="eEventPrintModal__itemDescription">
                      {item.disabled ? 'Add participants before generating this document.' : item.description}
                    </span>
                  </span>
                  <span className="eEventPrintModal__arrow" aria-hidden="true">
                    ›
                  </span>
                </button>
              ))}
            </div>
          </section>
        ))}
      </SimpleModal>
    );
  }

  openBasicTeamSheetReportForm = () => {
    this.setState({
      isBasicTeamSheetReportFormModalOpen: true
    });
  };

  closeBasicTeamSheetReportForm = () => {
    this.setState({
      isBasicTeamSheetReportFormModalOpen: false
    });
  };

  openExtendedTeamSheetReportForm = () => {
    this.setState({
      isExtendedTeamSheetReportFormModalOpen: true
    });
  };

  closeExtendedTeamSheetReportForm = () => {
    this.setState({
      isExtendedTeamSheetReportFormModalOpen: false
    });
  };

  openExtendedParticipantListReportForm = () => {
    this.setState({
      isExtendedParticipantListReportFormModalOpen: true
    });
  };

  closeExtendedParticipantListReportForm = () => {
    this.setState({
      isExtendedParticipantListReportFormModalOpen: false
    });
  };

  openEventConsentRequestsReportForm = () => {
    this.setState({
      isEventConsentRequestsReportFormModalOpen: true
    });
  };

  closeEventConsentRequestsReportForm = () => {
    this.setState({
      isEventConsentRequestsReportFormModalOpen: false
    });
  };

  openEventAvailabilityReportsReportForm = () => {
    this.setState({
      isEventAvailabilityReportsReportFormModalOpen: true
    });
  };

  closeEventAvailabilityReportsReportForm = () => {
    this.setState({
      isEventAvailabilityReportsReportFormModalOpen: false
    });
  };

  openEventScoreCardReportForm = () => {
    this.setState({
      isEventScoreCardReportFormModalOpen: true
    });
  };

  closeEventScoreCardReportForm = () => {
    this.setState({
      isEventScoreCardReportFormModalOpen: false
    });
  };

  openCautionsDismissalsReportForm = () => {
    this.setState({
      isCautionsDismissalsReportFormModalOpen: true
    });
  };

  closeCautionsDismissalsReportForm = () => {
    this.setState({
      isCautionsDismissalsReportFormModalOpen: false
    });
  };

  openStudentTargetCompletionReportForm = () => {
    this.setState({
      isStudentTargetCompletionReportFormModalOpen: true
    });
  };

  closeStudentTargetCompletionReportForm = () => {
    this.setState({
      isStudentTargetCompletionReportFormModalOpen: false
    });
  };

  openPaperAttendanceRegisterEventReportForm = () => {
    this.setState({
      isPaperAttendanceRegisterEventReportFormModalOpen: true
    });
  };

  closePaperAttendanceRegisterEventReportForm = () => {
    this.setState({
      isPaperAttendanceRegisterEventReportFormModalOpen: false
    });
  };

  printPaperAttendanceRegisterFixture = () => {
    const data = {
      isPrintXLSX: true,
      isPrintPDF: false
    };

    this.onSubmitReportForm(data, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PAPER_ATTENDANCE_REGISTER_FIXTURE);
  };

  printEventAttendanceLog = () => {
    this.onSubmitReportForm(
      { isPrintXLSX: true, isPrintPDF: false },
      REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EVENT_ATTENDANCE_LOG
    );
  };

  renderReportModalTitle = (title: string, category: string = 'Event report') => (
    <div className="eReportModalTitle">
      <span className="eReportModalTitle__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
        </svg>
      </span>
      <span className="eReportModalTitle__copy">
        <span className="eReportModalTitle__name">{title}</span>
        <span className="eReportModalTitle__category">{category}</span>
      </span>
    </div>
  );

  renderBasicTeamSheetReportFormModal() {
    const { user } = this.props;
    const { isBasicTeamSheetReportFormModalOpen, event } = this.state;
    const { activeSchoolId } = user;

    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isBasicTeamSheetReportFormModalOpen}
        title={this.renderReportModalTitle('Basic team sheet', 'Participants')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeBasicTeamSheetReportForm}
      >
        <BasicTeamSheetReportForm
          event={event}
          activeSchoolId={activeSchoolId}
          onCloseClick={this.closeBasicTeamSheetReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  renderExtendedTeamSheetReportFormModal() {
    const { user } = this.props;
    const { isExtendedTeamSheetReportFormModalOpen, event } = this.state;
    const { activeSchoolId } = user;

    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isExtendedTeamSheetReportFormModalOpen}
        title={this.renderReportModalTitle('Extended team sheet', 'Participants')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeExtendedTeamSheetReportForm}
      >
        <ExtendedTeamSheetReportForm
          event={event}
          activeSchoolId={activeSchoolId}
          onCloseClick={this.closeExtendedTeamSheetReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  renderExtendedParticipantListReportFormModal() {
    const { user } = this.props;
    const { isExtendedParticipantListReportFormModalOpen, event } = this.state;
    const { activeSchoolId } = user;

    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isExtendedParticipantListReportFormModalOpen}
        title={this.renderReportModalTitle('Extended participant list', 'Participants')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeExtendedParticipantListReportForm}
      >
        <ExtendedParticipantListReportForm
          event={event}
          activeSchoolId={activeSchoolId}
          onCloseClick={this.closeExtendedParticipantListReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  renderEventConsentRequestsReportFormModal() {
    const { isEventConsentRequestsReportFormModalOpen, event } = this.state;
    const { user } = this.props;
    const { activeSchoolId } = user;

    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isEventConsentRequestsReportFormModalOpen}
        title={this.renderReportModalTitle('Consent requests summary', 'Records & compliance')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeEventConsentRequestsReportForm}
      >
        <EventConsentRequestsReportForm
          onCloseClick={this.closeEventConsentRequestsReportForm}
          onSubmit={this.onSubmitReportForm}
          activeSchoolId={activeSchoolId}
        />
      </SimpleModal>
    );
  }

  renderEventAvailabilityReportsReportFormModal() {
    const { isEventAvailabilityReportsReportFormModalOpen, event } = this.state;

    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isEventAvailabilityReportsReportFormModalOpen}
        title={this.renderReportModalTitle('Availability reports summary', 'Records & compliance')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeEventAvailabilityReportsReportForm}
      >
        <EventAvailabilityReportsReportForm
          onCloseClick={this.closeEventAvailabilityReportsReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  renderEventScoreCardReportFormModal() {
    const { user } = this.props;
    const { isEventScoreCardReportFormModalOpen, event } = this.state;
    const { activeSchoolId } = user;

    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isEventScoreCardReportFormModalOpen}
        title={this.renderReportModalTitle('Event score card', 'On the day')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeEventScoreCardReportForm}
      >
        <EventScoreCardReportForm
          event={event}
          activeSchoolId={activeSchoolId}
          onCloseClick={this.closeEventScoreCardReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  renderCautionsDismissalsReportFormModal() {
    const { user } = this.props;
    const { isCautionsDismissalsReportFormModalOpen, event } = this.state;
    const { activeSchoolId } = user;

    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isCautionsDismissalsReportFormModalOpen}
        title={this.renderReportModalTitle('Cautions & dismissals', 'Records & compliance')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeCautionsDismissalsReportForm}
      >
        <CautionsDismissalsReportForm
          event={event}
          activeSchoolId={activeSchoolId}
          onCloseClick={this.closeCautionsDismissalsReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  renderStudentTargetCompletionReportFormModal() {
    const { isStudentTargetCompletionReportFormModalOpen, event } = this.state;

    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isStudentTargetCompletionReportFormModalOpen}
        title={this.renderReportModalTitle('Student target completion', 'Records & compliance')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeStudentTargetCompletionReportForm}
      >
        <StudentTargetCompletionReportForm
          onCloseClick={this.closeStudentTargetCompletionReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  renderPaperAttendanceRegisterEventReportFormModal() {
    const { user } = this.props;
    const { isPaperAttendanceRegisterEventReportFormModalOpen, event } = this.state;
    const { activeSchoolId } = user;

    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isPaperAttendanceRegisterEventReportFormModalOpen}
        title={this.renderReportModalTitle('Paper attendance register', 'On the day')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closePaperAttendanceRegisterEventReportForm}
      >
        <PaperAttendanceRegisterEventReportForm
          event={event}
          activeSchoolId={activeSchoolId}
          onCloseClick={this.closePaperAttendanceRegisterEventReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  onSubmitReportForm = (data, reportType) => {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { event, tabIndex } = this.state;
    const {
      isPrintFormName,
      isPrintYearGroup,
      isPrintGender,
      isPrintDOB,
      isPrintHouse,
      isPrintPP,
      isPrintSEN,
      isPrintFSM,
      isPrintPosition,
      isPrintMedicalInfo,
      isPrintNextOfKin,
      isPrintPhotoConsentOptOut,
      isShowAll,
      isPrintFullNames,
      schoolId,
      eventId,
      teamId,
      isPrintDescription,
      isPrintKitNotes,
      isPrintComments,
      isPrintTransportDetails,
      isPrintOppositionContactDetails,
      isPrintMembersOfStaff,
      isPrintEventTimings,
      isPrintPOM,
      isShowCompleted,
      isShowUncompleted,
      isPrintXLSX,
      isPrintPDF,
      isThisEvent,
      isFutureEvents,
      isAllEvents
    } = data;

    let modData;

    switch (reportType) {
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EXTENDED_TEAM_SHEET:
        this.setState({
          isExtendedTeamSheetReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id,
            printFormName: isPrintFormName,
            printYearGroup: isPrintYearGroup,
            printGender: isPrintGender,
            printDOB: isPrintDOB,
            printHouse: isPrintHouse,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printPhotoConsentOptOut: isPrintPhotoConsentOptOut,
            printPosition: isPrintPosition,
            printMedicalInfo: isPrintMedicalInfo,
            printNextOfKin: isPrintNextOfKin,
            printDescription: isPrintDescription,
            printKitNotes: isPrintKitNotes,
            printComments: isPrintComments,
            printTransportDetails: isPrintTransportDetails,
            printOppositionContactDetails: isPrintOppositionContactDetails,
            printMembersOfStaff: isPrintMembersOfStaff,
            printEventTimings: isPrintEventTimings,
            printXLSX: isPrintXLSX,
            printPDF: isPrintPDF
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EXTENDED_PARTICIPANT_LIST:
        this.setState({
          isExtendedParticipantListReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id,
            printFormName: isPrintFormName,
            printYearGroup: isPrintYearGroup,
            printGender: isPrintGender,
            printDOB: isPrintDOB,
            printHouse: isPrintHouse,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printPhotoConsentOptOut: isPrintPhotoConsentOptOut,
            printPosition: isPrintPosition,
            printMedicalInfo: isPrintMedicalInfo,
            printNextOfKin: isPrintNextOfKin,
            printDescription: isPrintDescription,
            printKitNotes: isPrintKitNotes,
            printComments: isPrintComments,
            printTransportDetails: isPrintTransportDetails,
            printOppositionContactDetails: isPrintOppositionContactDetails,
            printMembersOfStaff: isPrintMembersOfStaff,
            printEventTimings: isPrintEventTimings,
            printXLSX: isPrintXLSX,
            printPDF: isPrintPDF
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EVENT_CONSENT_REQUESTS:
        this.setState({
          isEventConsentRequestsReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id,
            printMedicalInfo: isPrintMedicalInfo,
            printNextOfKin: isPrintNextOfKin,
            printResponseMetadata: true
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EVENT_AVAILABILITY_REPORTS:
        this.setState({
          isEventAvailabilityReportsReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id,
            showAll: isShowAll
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.BASIC_TEAM_SHEET:
        this.setState({
          isBasicTeamSheetReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id,
            teamId: teamId,
            printFullNames: isPrintFullNames,
            printPhotoConsentOptOut: isPrintPhotoConsentOptOut,
            printDescription: isPrintDescription,
            printKitNotes: isPrintKitNotes,
            printComments: isPrintComments,
            printTransportDetails: isPrintTransportDetails,
            printOppositionContactDetails: isPrintOppositionContactDetails,
            printMembersOfStaff: isPrintMembersOfStaff,
            printEventTimings: isPrintEventTimings,
            printXLSX: isPrintXLSX,
            printPDF: isPrintPDF
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.BASIC_TEAM_SHEET_INDIVIDUAL:
        this.setState({
          isBasicTeamSheetReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId,
            eventId,
            printFullNames: isPrintFullNames,
            printPhotoConsentOptOut: isPrintPhotoConsentOptOut,
            printDescription: isPrintDescription,
            printKitNotes: isPrintKitNotes,
            printComments: isPrintComments,
            printTransportDetails: isPrintTransportDetails,
            printOppositionContactDetails: isPrintOppositionContactDetails,
            printMembersOfStaff: isPrintMembersOfStaff,
            printEventTimings: isPrintEventTimings,
            printXLSX: isPrintXLSX,
            printPDF: isPrintPDF
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EVENT_SCORE_CARD:
        this.setState({
          isEventScoreCardReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id,
            printPOM: isPrintPOM
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CAUTIONS_DISMISSALS:
        this.setState({
          isCautionsDismissalsReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id,
            printFullNames: isPrintFullNames,
            printComments: isPrintComments
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.STUDENT_TARGET_COMPLETION:
        this.setState({
          isStudentTargetCompletionReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id,
            showCompleted: isShowCompleted,
            showUncompleted: isShowUncompleted
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PAPER_ATTENDANCE_REGISTER_EVENT:
        this.setState({
          isPaperAttendanceRegisterEventReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id,
            thisEvent: isThisEvent,
            futureEvents: isFutureEvents,
            allEvents: isAllEvents
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PAPER_ATTENDANCE_REGISTER_FIXTURE:
        this.setState({
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id
          }
        };
        break;
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EVENT_ATTENDANCE_LOG:
        this.setState({
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            eventId: event.id
          }
        };
        break;
    }

    uploadReport(user, reportType, modData)
      .then(data => {
        if (typeof data.reportId !== 'undefined') {
          const reportType = data.reportType;
          this.setState({
            isLoading: false
          });

          let fileType;

          switch (true) {
            case isPrintPDF:
              fileType = REPORT_PRINT_FORMAT.PDF;
              break;
            case isPrintXLSX:
              fileType = REPORT_PRINT_FORMAT.XLSX;
              break;
            default:
              fileType = REPORT_PRINT_FORMAT.XLSX;
              break;
          }

          const url = `${window.apiBase}/public/report/${data.reportId}/reportType/${reportType}/fileType/${fileType}`;
          window.open(url);

          this.reloadEvent(tabIndex);
        }
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');

        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });

        this.reloadEvent(tabIndex);
      });
  };

  goBack = () => {
    const { event } = this.state;
    const { history, location } = this.props;
    const { state } = location;
    const { prevRoutePath, filter } = state as any;

    const selectedDate = propz.get(event, ['startTime']);

    const isSelectedDateExist = typeof selectedDate !== 'undefined';
    const isFilterExist = typeof filter !== 'undefined';

    const data: any = {
      pathname: prevRoutePath,
      state: {}
    };

    switch (true) {
      case isFilterExist:
        data.state.filter = filter;
        break;

      case isSelectedDateExist:
        data.state.filter = filter;
        break;
    }

    if (isFilterExist) {
      data.state.selectedDate = selectedDate;
    }

    history.push(data);
  };

  maybeAutoAssignKitForCurrentSchool = () => {
    const { user } = this.props;
    const { event } = this.state;

    if (!event) return;
    if (isClubEvent(event)) return;

    const activeSchoolId = propz.get(user, ['activeSchoolId'], '');
    if (!activeSchoolId) return;

    const sportId = propz.get(event, ['sportId']);
    const gender = propz.get(event, ['gender']);
    if (!sportId || !gender) return;

    const isNonTeam = isNonTeamSportEvent(event);
    const isTeam = isTeamOrTwoOnTwoSportEvent(event);
    if (!isNonTeam && !isTeam) return;

    const detailsKits = (propz.get(event, ['eventDetails', 'kitLabKits'], []) || []) as any[];

    if (isNonTeam) {
      if (detailsKits.length > 0) return;

      getKitLabKits(user)
        .then(allKits => {
          if (!Array.isArray(allKits) || !allKits.length) return null;

          const kit = pickKitForEvent(allKits, String(sportId), gender as any);
          if (!kit) return null;

          const payload = {
            kitLabKits: [
              {
                kitId: kit._id
              }
            ]
          };

          return updateSchoolEventDetails(user, event.id, payload)
            .then(() => getSchoolEvent(user, event.id))
            .catch(err => {
              console.error('[KIT-AUTO][VIEW][NON-TEAM] update failed', err);
              return null;
            });
        })
        .then(updatedEvent => {
          if (updatedEvent) {
            this.setState({ event: updatedEvent });
          }
        })
        .catch(err => {
          console.error('[KIT-AUTO][VIEW][NON-TEAM] general error', err);
        });

      return;
    }

    if (isTeam) {
      const embeddedTeams = (propz.get(event, ['embeddedTeams'], []) || []) as any[];

      const teamsForSchool = embeddedTeams.filter(t => {
        const schoolId = propz.get(t, ['schoolId']);
        return schoolId && String(schoolId) === String(activeSchoolId);
      });

      if (!teamsForSchool.length) return;

      const teamIdsWithKit = new Set(
        detailsKits
          .map(k => propz.get(k, ['teamId'], null))
          .filter(id => !!id)
          .map(id => String(id))
      );

      const teamsWithoutKit = teamsForSchool.filter(t => {
        const teamId = String(t.id || t._id || '');
        if (!teamId) return false;
        return !teamIdsWithKit.has(teamId);
      });

      if (!teamsWithoutKit.length) return;

      getKitLabKits(user)
        .then(allKits => {
          if (!Array.isArray(allKits) || !allKits.length) return null;

          const mappings: any[] = [];

          teamsWithoutKit.forEach(team => {
            const teamId = String(team.id || team._id || '');
            if (!teamId) return;

            let kit = getExplicitTeamKitFromTeam(team, allKits);

            if (!kit) {
              kit = pickKitForEvent(allKits, String(sportId), gender as any);
            }

            if (!kit) return;

            mappings.push({
              teamId,
              kitId: kit._id
            });
          });

          if (!mappings.length) return null;

          const existingKits = Array.isArray(detailsKits) ? detailsKits : [];
          const mergedKits = existingKits.concat(mappings);

          const payload = {
            kitLabKits: mergedKits
          };

          return updateSchoolEventDetails(user, event.id, payload)
            .then(() => getSchoolEvent(user, event.id))
            .catch(err => {
              console.error('[KIT-AUTO][VIEW][TEAM] update failed', err);
              return null;
            });
        })
        .then(updatedEvent => {
          if (updatedEvent) {
            this.setState({ event: updatedEvent });
          }
        })
        .catch(err => {
          console.error('[KIT-AUTO][VIEW][TEAM] general error', err);
        });

      return;
    }
  };

  render() {
    const {
      isLoading,
      prevEvent,
      nextEvent,
      event,
      isResultsModalOpen,
      isExtraPointsModalOpen,
      isEditableEventSettings,
      isSendNotificationModalOpen,
      isSendNotificationEligibleStudentsModalOpen,
      isVideoModalOpen,
      isErrorModalOpen,
      isAddSchoolModalOpen,
      isRemoveParticipantModalOpen,
      isChangeSchoolModalOpen,
      tabIndex,
      isSendConsentRequestModalOpen,
      isSuccessSendConsentRequestModalOpen,
      isShowCreateAnotherEventAlert,
      participants,
      isExtendedTeamSheetReportFormModalOpen,
      isExtendedParticipantListReportFormModalOpen,
      isEventConsentRequestsReportFormModalOpen,
      isEventAvailabilityReportsReportFormModalOpen,
      isBasicTeamSheetReportFormModalOpen,
      isEventScoreCardReportFormModalOpen,
      isCautionsDismissalsReportFormModalOpen,
      isStudentTargetCompletionReportFormModalOpen,
      isPaperAttendanceRegisterEventReportFormModalOpen,
      isPrintSelectionModalOpen
    } = this.state;
    const { user, history, location } = this.props;

    const prevRoutePath = propz.get(location, ['state', 'prevRoutePath']);
    const isPrevRoutePathExist = typeof prevRoutePath !== 'undefined' && prevRoutePath !== '';

    if (isLoading) {
      return <Loader />;
    }

    if (this.isSendConsentRequestPageOpen()) {
      return this.renderSentConsentRequestPage();
    }

    const isParticipantsExist = participants.length > 0;

    const callbacks = this.getCallbacks();
    const actionItems = getActionList(user, event, callbacks);

    const actionItemsUpdated = getActionListWithSubItems(actionItems);

    const printAction = actionItemsUpdated.find(item => item.itemText === 'Print');
    if (printAction) {
      printAction.onItemClick = this.openPrintSelectionModal;
      printAction.isActive = isParticipantsExist;
      delete printAction.subItems;
    } else {
      actionItemsUpdated.push({
        itemText: 'Print',
        isActive: isParticipantsExist,
        onItemClick: this.openPrintSelectionModal
      });
    }

    const isPrevEventExist = typeof prevEvent !== 'undefined';
    const isNextEventExist = typeof nextEvent !== 'undefined';

    const classes =
      isResultsModalOpen ||
      isEditableEventSettings ||
      isSendNotificationModalOpen ||
      isVideoModalOpen ||
      isSendNotificationEligibleStudentsModalOpen ||
      isErrorModalOpen ||
      isExtraPointsModalOpen ||
      isAddSchoolModalOpen ||
      isRemoveParticipantModalOpen ||
      isChangeSchoolModalOpen ||
      this.isSendConsentRequestPageOpen() ||
      isSuccessSendConsentRequestModalOpen ||
      isExtendedTeamSheetReportFormModalOpen ||
      isExtendedParticipantListReportFormModalOpen ||
      isEventConsentRequestsReportFormModalOpen ||
      isEventAvailabilityReportsReportFormModalOpen ||
      isBasicTeamSheetReportFormModalOpen ||
      isEventScoreCardReportFormModalOpen ||
      isCautionsDismissalsReportFormModalOpen ||
      isStudentTargetCompletionReportFormModalOpen ||
      isPaperAttendanceRegisterEventReportFormModalOpen ||
      isPrintSelectionModalOpen
        ? 'schoolEventPage modal-open'
        : 'schoolEventPage';

    return (
      <div className={classes}>
        {this.renderResultsModal()}
        {this.renderResultsDiscardModal()}
        {this.renderExtraPointsModal()}
        {this.renderExtraPointsDiscardModal()}
        {this.renderEventSettingModal()}
        {this.renderCancelEventModal()}
        {this.renderUncancelEventModal()}
        {this.renderDeleteEventModal()}
        {this.renderSuccessDeleteEventModal()}
        {this.renderSendNotificationsModal()}
        {this.renderSendNotificationEligibleStudentsModal()}
        {this.renderVideoModal()}
        {this.renderVideoFileInput()}
        {this.renderError()}
        {this.renderAddSchoolModal()}
        {this.renderChangeSchoolModal()}
        {this.renderRemoveParticipantModal()}
        {this.renderSentConsentRequestPage()}
        {this.renderSuccessSendConsentRequestModal()}
        {this.renderTwitterModal()}
        {this.renderSuccessPostedModal()}
        {this.renderMapModal()}
        {this.renderPrintSelectionModal()}
        {this.renderBasicTeamSheetReportFormModal()}
        {this.renderExtendedTeamSheetReportFormModal()}
        {this.renderExtendedParticipantListReportFormModal()}
        {this.renderEventConsentRequestsReportFormModal()}
        {this.renderEventAvailabilityReportsReportFormModal()}
        {this.renderEventScoreCardReportFormModal()}
        {this.renderCautionsDismissalsReportFormModal()}
        {this.renderStudentTargetCompletionReportFormModal()}
        {this.renderPaperAttendanceRegisterEventReportFormModal()}
        {isShowCreateAnotherEventAlert && (
          <div className={'bCreateOtherEventPanelWrapper'}>
            <SchoolEventsCreateAnotherEventAlert
              history={history}
              onCreateAnotherEventAlertCloseClick={this.onCreateAnotherEventAlertCloseClick}
            />
          </div>
        )}

        <header className="schoolEventPage__header">
          <div className="schoolEventPage__backRow">
            <button type="button" onClick={isPrevRoutePathExist ? this.goBack : () => history.goBack()}>
              <span aria-hidden="true">←</span> Back to events
            </button>
            <span className="schoolEventPage__backDivider" aria-hidden="true" />
            <strong>{getEventGeneratedName(event, { user })}</strong>
          </div>
          <SchoolEventMainInformation
            user={user}
            event={event}
            participants={participants}
            actionItems={actionItemsUpdated}
            isPrevButtonDisabled={!isPrevEventExist}
            isNextButtonDisabled={!isNextEventExist}
            onPrevEventClick={this.onPrevEventClick}
            onNextEventClick={this.onNextEventClick}
            onViewMapClick={this.openMapModal}
          />
        </header>
        <section className="schoolEventPage__workspace">
          <SchoolEventTabs
            history={history}
            participants={participants}
            user={user}
            eventInitial={event}
            tabIndex={tabIndex}
            reloadEvent={this.reloadEvent}
            onRemoveParticipantClick={this.onRemoveParticipantClick}
            onChangeSchoolClick={this.onChangeSchoolClick}
          />
        </section>
      </div>
    );
  }
}
